/**
 * Komplette autentiske tekster fra verdensbedsteskole.dk (Odder Lille Friskole)
 * Indeholder alle undersider, overskrifter, lister og dokumentreferencer.
 */

export const scrapedPages = {
  // 1. Om os
  "om-os": {
    slug: "om-os",
    title: "Om os",
    summary: "En selvejende og uafhængig friskole i hjertet af Odder baseret på stærke skoleværdier og dannelse af fordomsfrie verdensborgere.",
    category: "Om skolen",
    hero_image: ["https://assets.auxodev.dk/assets/7e157867-df92-46f8-b5ca-20179d4d9044/olf2_62709655.jpg"],
    content: `
      <h2>Friskole i Odder</h2>
      <p>Odder lille Friskole er som navnet siger en friskole og dermed underlagt Friskoleloven. Den er en selvejende og uafhængig uddannelsesinstitution som skal have et sæt vedtægter, der godkendes af undervisningsministeriet.</p>
      <p>Odder lille Friskole er politisk- og religiøs uafhængig og neutral.</p>

      <h2>Uddanne verdensborgere</h2>
      <p>Det at evne at se værdierne hos andre og kunne være interesseret og se den mangfoldighed, der er i andre mennesker, er vores mål for dannelsen af eleverne på Odder lille Friskole. Vi vil fremme nysgerrigheden. Det gør vi blandt andet ved at have nogle stærke grundlæggende skoleværdier, værdier skabt i fællesskabet.</p>
      <p>Vi vil uddanne verdensborgere, der er fordomsfri, der kan se andre og omverdenen som værdifulde. Det gør vi bla. gennem tolerence, respekt og ansvarsfuldhed.</p>

      <blockquote>
        "Odder lille Friskole ligger midt i Odder by og er en fri grundskole med klassetrin fra 0. – 9. klasse. Skolen har ca. 160 elever med max. 16-18 elever i hver klasse. Vi glæder os til at byde dig velkommen i fællesskabet!"
      </blockquote>
    `
  },

  // Alias for om-skolen
  "om-skolen": {
    slug: "om-skolen",
    title: "Om os",
    summary: "En selvejende og uafhængig friskole i hjertet af Odder baseret på stærke skoleværdier og dannelse af fordomsfrie verdensborgere.",
    category: "Om skolen",
    hero_image: ["https://assets.auxodev.dk/assets/7e157867-df92-46f8-b5ca-20179d4d9044/olf2_62709655.jpg"],
    content: `
      <h2>Friskole i Odder</h2>
      <p>Odder lille Friskole er som navnet siger en friskole og dermed underlagt Friskoleloven. Den er en selvejende og uafhængig uddannelsesinstitution som skal have et sæt vedtægter, der godkendes af undervisningsministeriet.</p>
      <p>Odder lille Friskole er politisk- og religiøs uafhængig og neutral.</p>

      <h2>Uddanne verdensborgere</h2>
      <p>Det at evne at se værdierne hos andre og kunne være interesseret og se den mangfoldighed, der er i andre mennesker, er vores mål for dannelsen af eleverne på Odder lille Friskole. Vi vil fremme nysgerrigheden. Det gør vi blandt andet ved at have nogle stærke grundlæggende skoleværdier, værdier skabt i fællesskabet.</p>
      <p>Vi vil uddanne verdensborgere, der er fordomsfri, der kan se andre og omverdenen som værdifulde. Det gør vi bla. gennem tolerence, respekt og ansvarsfuldhed.</p>

      <blockquote>
        "Odder lille Friskole ligger midt i Odder by og er en fri grundskole med klassetrin fra 0. – 9. klasse. Skolen har ca. 160 elever med max. 16-18 elever i hver klasse. Vi glæder os til at byde dig velkommen i fællesskabet!"
      </blockquote>
    `
  },

  // 2. Værdigrundlag
  "vaerdigrundlag": {
    slug: "vaerdigrundlag",
    title: "Værdigrundlag",
    summary: "At samle børn, forældre og lærere i et aktivt fællesskab med tryghed, frihed, folkestyre og lyst til læring.",
    category: "Om skolen",
    hero_image: ["https://assets.auxodev.dk/assets/7e157867-df92-46f8-b5ca-20179d4d9044/olf10.jpg"],
    content: `
      <h2>Formål</h2>
      <p>At samle børn, forældre og lærere i et aktivt fællesskab. Sammen varetager vi dannelsen af børnene og skaber rammer for en undervisning, der søger og udvikler børnenes kreativitet, evne til at tænke selvstændigt og opleve i helheder.</p>

      <h2>Værdier</h2>
      <p>Odder lille Friskole bygger på demokrati. Ved det forstår vi medbestemmelse, gensidig ansvarlighed, tryghed og hensyntagen i alle forhold. Det er en friskole, hvor enhver har frihed til at tro, mene og ytre sig efter sin overbevisning, selvfølgelig i respekt for såvel den enkelte som for fællesskabet. Lyst til læring er for os et centralt begreb.</p>

      <h2>Frihed &amp; folkestyre</h2>
      <p>På Odder lille Friskole forbereder vi eleverne til frihed og folkestyre gennem materialevalg, undervisningsmetodik, arbejdsform, debat og stillingtagen samt forskellige andre tiltag. I samfundsfag er det feks. selve fagets natur at forberede til frihed og folkestyre, herunder ligestilling og tolerance. Det opnås ved at lægge vægt på de institutioner f.eks. kommuner, regioner, Folketinget, EU, FN, UNICEF etc. som netop har folkestyre, demokrati og frihed som formål. I dansk gøres det bl.a. ved materialevalg.</p>
      <p>En del af de materialer, vi arbejder med er blevet til, i ønsket om og nødvendigheden af frihed og folkestyre. Det samme gør sig gældende inde for sprogfagene. I undervisningen har vi bl.a. anvendt diskussion, forholden sig til, ret til at ytre sig og blive anerkendt for dette.</p>

      <h2>Frihed &amp; folkestyre i skolen</h2>
      <p>Frihed og folkestyre i skolens kontakt med den enkelte elev og på klasseniveau.</p>
      <p>Værdierne, traditionerne og ånden på Odder lille Friskole er med til at skabe grobund for elevernes fremadrettede tro på demokratiets styrker, rettigheder, nødvendighed og pligter i forhold til samfundet, deri blandt at tage stilling og tage ansvar.</p>
      <p>Derudover er der løbende samtaler på klasseniveau med klasselærere. I samværet på Odder lille Friskole er vi meget opmærksomme på, at eleverne bliver inspireret og motiveret til tolerance og demokrati.</p>
      <p>Grundlæggende kan man først på længere sigt vurdere, om de tiltag skolen har taget i forhold til frihed og folkestyre, har båret frugt. Dog kan vi også i den daglige undervisning løbende se resultater af bestræbelserne på, om eleverne er gearet til selvstændig stillingtagen, til at tage ansvar, danne meninger og holdninger ud fra egen overbevisning og medleven i et demokratisk samfund.</p>
      <p>Gennem elevrådsarbejdet diskuteres det faglige indhold, emner og undervisningsformer. Vi har også en høj prioritering af arrangementer, der lægger vægt på elevernes opdragelse til frihed, folkestyre og tolerance.</p>

      <h2>Forberedelse</h2>
      <p>Det er mere formen end selve fagets natur der involverer eleverne demokratisk. I den afsluttende evaluering af elevernes forskellige arbejde er der lagt meget op til en demokratisk proces ved fremlæggelser.</p>

      <h2>Frihed og folkestyre i skolens øvrige aktiviteter</h2>
      <p>Af øvrige aktiviteter der finder sted på skolen som lægger op til frihed og folkestyre kunne bl.a. nævnes:</p>
      <ul>
        <li>Morgensang</li>
        <li>Fællesmøder der styres af eleverne i 8 kl.</li>
        <li>Elevråd</li>
        <li>Klasseråd</li>
        <li>Fællesarrangementer</li>
        <li>Projektuger, hvor der bla. bliver arbejdet med børnekonventionen og børns rettigheder samt identitet, lighed mellem kønnene m.m.</li>
        <li>Deltagelse i skolevalg, hvor undervisningen op til dette er præget af diskussion om demokrati, ytringsfrihed, værdier, kultur – kort sagt, frihed og folkestyre.</li>
      </ul>

      <h2>Fællesskab</h2>
      <p>Gennem et gensidigt, forpligtende samvær mellem elever, forældre og ansatte opstår et fællesskab som omfatter den daglige skolegang, og som sikrer udviklingen af et dynamisk og inspirerende undervisningsmiljø, hvor der dannes grobund for udvikling og nyskabelse.</p>

      <h2>Demokrati, ligestilling og indflydelse</h2>
      <p>Eleverne oplever gennem skoleforløbet indgangen til et demokratisk samfund, hvor deres synspunkter og ønsker bliver hørt, med ligestilling og medbestemmelse på forskellige områder i dagligdagen. Omfanget af indflydelse øges naturligt op gennem årgangene, i rammer hvor dette kan lade sig gøre.</p>

      <h2>Samarbejde og medansvar</h2>
      <p>Eleverne lærer at samarbejde. Både med forskellige mennesketyper og aldersgrupper, om forskellige opgaver og i forskellige sammenhænge.</p>
      <p>Vi lægger stor vægt på den enkeltes medansvar, uanset om det drejer sig om teoretiske krav eller praktiske opgaver og gøremål. Skolen vægter en undervisning, der er baseret på elevens aktive medvirken i læringsprocessen. Vi tror på, at den enkelte elev herigennem opnår en styrkelse af evnen til at håndtere sociale relationer mennesker imellem.</p>

      <h2>Muligheder frem for begrænsninger</h2>
      <p>Tankegangen bag de forskellige opdelinger af eleverne bygger på mangfoldighed. Ved at tilbyde forskellige undervisnings- og læringsmetoder opdelt i forskellige strukturer kommer eleverne gennem en vifte af valg og muligheder, som sætter dem i stand til at benytte disse i andre sammenhænge. Det betyder, at den enkelte elev gennem skoleforløbet får en oplevelse af at kunne tænke kreativt og af selv at kunne handle.</p>
    `
  },

  // Alias vaerdier
  "vaerdier": {
    slug: "vaerdier",
    title: "Værdigrundlag",
    summary: "At samle børn, forældre og lærere i et aktivt fællesskab med tryghed, frihed, folkestyre og lyst til læring.",
    category: "Om skolen",
    hero_image: ["https://assets.auxodev.dk/assets/7e157867-df92-46f8-b5ca-20179d4d9044/olf10.jpg"],
    content: `
      <h2>Formål</h2>
      <p>At samle børn, forældre og lærere i et aktivt fællesskab. Sammen varetager vi dannelsen af børnene og skaber rammer for en undervisning, der søger og udvikler børnenes kreativitet, evne til at tænke selvstændigt og opleve i helheder.</p>
      <h2>Værdier</h2>
      <p>Odder lille Friskole bygger på demokrati. Ved det forstår vi medbestemmelse, gensidig ansvarlighed, tryghed og hensyntagen i alle forhold. Det er en friskole, hvor enhver har frihed til at tro, mene og ytre sig efter sin overbevisning, selvfølgelig i respekt for såvel den enkelte som for fællesskabet. Lyst til læring er for os et centralt begreb.</p>
      <h2>Frihed &amp; folkestyre</h2>
      <p>På Odder lille Friskole forbereder vi eleverne til frihed og folkestyre gennem materialevalg, undervisningsmetodik, arbejdsform, debat og stillingtagen samt forskellige andre tiltag.</p>
      <h2>Fællesskab &amp; Medansvar</h2>
      <p>Gennem et gensidigt, forpligtende samvær mellem elever, forældre og ansatte opstår et fællesskab som omfatter den daglige skolegang, og som sikrer udviklingen af et dynamisk og inspirerende undervisningsmiljø.</p>
    `
  },

  // 3. Optagelse og indmeldelse
  "optagelse-og-indmeldelse": {
    slug: "optagelse-og-indmeldelse",
    title: "Optagelse og indmeldelse",
    summary: "Digital optagelsesprocedure med MitID for kommende elever samt information om søskendegaranti og samtaler.",
    category: "Ny på skolen",
    hero_image: ["https://assets.auxodev.dk/assets/7e157867-df92-46f8-b5ca-20179d4d9044/olf2_62709655.jpg"],
    content: `
      <h2>Optagelse og indmeldelse på Odder lille Friskole</h2>
      <p>Vi har en ny digital optagelsesprocedure for kommende 0. klasses elever.</p>
      <p>Odder lille Friskole er en friskole der er anderledes på mange måder. Det er vi glade for.</p>
      <p>Vores struktur er en del af vores gruppesammensætninger i skoledagen f.eks. familiegrupper, vores projektperioder, prøvefrihed, forældreforpligtelser m.m. Derfor er det også vigtigt, at både forældre og skole har en god dialog omkring skolen, og om det er det rigtige valg for det enkelte barn og familien. På den måde kan kommende forældre få en mulighed for at forstå vores skole og vores værdier, så de ved hvad de går ind til. Skolen kan derfor også danne sig et indtryk af barnet og familien.</p>
      <p>For skolen handler det ikke om at ekskludere nogen. Men om at være sikker på, at det er et velovervejet valg der træffes.</p>
      <p>At vælge skole er en stor beslutning, og derfor er det vigtigt, at der bliver taget aktivt stilling til det både fra skolen og forældrene. På den måde er man helt på det rene med, at man vælger friskolen til og er enig i vores værdier. Samt finder ud af om vi er skolen for netop dit barn og dets behov. Det vigtigt for jer som forældre, at I kender processen så snart I skriver barnet op, samt har en forståelse for, at vi er en skole som stiller krav til børn og forældre.</p>
      <p>Vi er en skole for rigtig mange, men ikke nødvendigvis det bedste skoletilbud for alle. Derfor vil vi hurtigst muligt sikre, at processen bliver så god en oplevelse for alle som muligt. Vores håb er, at processen giver gennemsigtighed i forhold til evt. optagelse.</p>

      <h2>Selve processen forløber således:</h2>
      <ol>
        <li>
          <strong>Forældre kan skrive deres barn op til enhver tid.</strong> Dette foregår med MitID via hjemmesiden www.verdensbedsteskole.dk. Indskrivning kan KUN gøres der, og ikke ved personligt fremmøde på skolen. Man kommer på listen til det ønskede skoleår, men kan ikke se hvilket nummer man er på ventelisten. Når man har indskrevet via MitID, modtager både forældre og skole en kvittering. Indskrivning af barnet kan KUN gøres digitalt med MitID. Det er VIGTIGT, at man ved indskrivning skriver, hvis man har søskende på skolen!
        </li>
        <li>
          <strong>I første omgang har vi fokus på 18 elever.</strong> Søskende og medarbejders børn har førsteret og er sikret en plads, med mindre der er omstændigheder der viser noget andet. Søskende skal også indskrives via hjemmesiden med MitID. De får ikke automatisk en plads, selvom de har en søskende på skolen. Udover det, vægter vi en så ligelig kønsfordeling som muligt. Derfor kan vi være nødsaget til at “hoppe” i listen for at sikre den fordeling kommer på plads til at starte med.
        </li>
        <li>
          <strong>Som udgangpunkt afholder vi kun samtaler med de børn der ikke har søskende på skolen i forvejen</strong>, med mindre der er søskende der giver anledning til en samtale. Ved indkaldelse til samtale, bliver der medsendt et skema man skal udfylde, og sende retur til skolen inden samtalen. Både nye børn og søskende skal udfylde skemaet. Skemaet er en vigtig del af vurderingen i forhold til pladsen.
        </li>
      </ol>

      <p>De søskende hvis familier vi kender godt, og som ikke giver anledning til yderligere samtale, indkaldes ikke. Samtalerne bliver afholdt i sep/okt. før efterårsferien, året før skolestart. Man skal påregne, at det ca. tager 30 minutter i alt. Samtalen er uden barnet. Det foregår på den måde, at man som familie bliver indkaldt til et møde med skoleleder, 0. kl. lærer og en pædagog.</p>

      <h3>Skoleleder vil overordnet fortælle om:</h3>
      <ul>
        <li>Skolen</li>
        <li>Struktur</li>
        <li>Værdierne og fællesskab</li>
        <li>Forældreinvolvering og forpligtelser</li>
        <li>Hvad der forventes af forældre på OLF</li>
      </ul>

      <h3>0. kl. læreren vil fortælle om:</h3>
      <ul>
        <li>Opstart i 0. kl</li>
        <li>Undervisningen og strukturen i klassen</li>
        <li>Hvad børnene skal kunne inden opstart, samt hvad vi forventer praktisk, socialt, modenhedsmæssigt m.m.</li>
      </ul>

      <h3>Pædagogen fortæller om:</h3>
      <ul>
        <li>Tidlig fritter (1. april) og opstart</li>
        <li>Alm. Fritter</li>
      </ul>

      <p>Udover det, vil vi fra forældrene gerne høre om barnet generelt, hvordan det trives, dets modenhed, hvordan det fungerer i hverdagen, selvhjulpenhed m.m. og selvfølgelig hvorfor forældrene har valgt netop OLF? Samt om der er nogle ting vi som skole skal være opmærksom på mht. udfordringer eller andet.</p>

      <p><strong>Når man kommer på klasselisten siger man samtidig ja til at starte i tidlig fritter d. 1. april og frem til skolestart i august. Hvis ikke man kan sige ja til det går pladsen videre til en anden.</strong></p>
      <p>Grunden til dette er, at vi vægter, at det er vigtigt for børnegruppen som helhed at starte sammen. Når de gør det, vil det sociale aspekt styrkes, og der vil være ens afsæt for alle i en ny klasse. Det er her de første relationer bliver etableret og prøvet af, venskaber bliver til, men også de indledende øvelser i at være en ny gruppe, finde ud af hvem hinanden er, få etableret en klassekultur og meget mere. Sammen stifter de bekendtskab med skolen og finder ud af hvordan den fungere inden det rigtig går “løs” på første skoledag.</p>

      <p>Der bliver holdt infomøde først i marts for den nye klasse samt forældre, inden man starter i april.</p>
      <p>Udover det, skal der indbetales et ikke refunderbart beløb (svarende til en mdr. skolepenge). Dette sker i forbindelse med at blive skrevet op på den færdige liste (altså efter samtale og godkendelse).</p>
    `
  },

  // 4. Eksamensfri
  "eksamensfri": {
    slug: "eksamensfri",
    title: "Prøve- og karakterfri skole",
    summary: "På Odder Lille Friskole er vi prøve- og karakterfri – eleverne udvikler sig uden karakterræs og afslutter med et tværfagligt projekt og personlig udtalelse.",
    category: "Om skolen",
    hero_image: ["https://assets.auxodev.dk/assets/7e157867-df92-46f8-b5ca-20179d4d9044/2.jpg"],
    content: `
      <h2>Odder Lille Friskole er prøve- og karakterfri</h2>
      <p>Det betyder i alt sin enkelhed, at vi ikke tilbyder folkeskolens 9 klasseprøver, vi har ikke karakterer, vi har ikke standpunktskarakterer og vi har ikke nationale tests, som man kender det fra folkeskolen.</p>
      <p>Eleverne i 9. klasse har et stort tværfagligt afslutningsprojekt, der omfatter både en teoretisk, praktisk og en performancedel.</p>
      <p>Projektet fremlægges for både klassekammerater, skolen, forældre og andre interesserede.</p>
      <p>Som afgangsbevis modtager OLF-elever en detaljeret udtalelse, hvori lærerne har beskrevet elevens faglige kompetencer og deres personlige udvikling gennem skoleforløbet.</p>

      <h2>Overbygning uden afgangsprøver</h2>
      <p>Siden Odder lille Friskole blev oprettet, har skolen været eksamensfri og vi har i mange år haft gode erfaringer med at sende elever videre i uddannelsessystemet uden afgangsprøver. Det er foregået helt udramatisk og uden at nogle af vore elever har oplevet sig bremset i uddannelsessystemet, eller lave det de ønskede sig.</p>
      <p>Hvis en elev ønsker at gå direkte fra 9. klasse til gymnasiet, skal de, da vi ikke giver karakterer, til en optagelsesprøve på gymnasiet. Prøven består af en 4 timers prøve med spørgsmål fra 4 forskellige fag, (dansk, engelsk, matematik og Fysik/Kemi) Ud fra denne prøve skal de totalt have min. 80 point (60 point til HF). De 80 point er ikke 20 point i hvert fag, men er bare 80 point i alt.</p>
      <p>Vi har også et godt samarbejde med UU-vejledningen i Skanderborg/Odder, som hjælper eleverne med at finde ud af, hvad de vil efter 9 klasse.</p>
      <p>Bliver undervisningen anderledes på en skole som vores? Ja det gør den. Der er mulighed for i langt højere grad, at tage udgangspunkt i den enkelte elevs behov og faglige udfordringer. Vi kan tilrettelægge undervisningen, så den er tilpasset den enkelte gruppe elever, vi kan vælge at blande det teoretiske med det praktiske, og vi har hvert år tiden helt frem til sommerferien, som vi kan udnytte til undervisning uden afbræk af prøver eller eksamen. Og der er god mulighed for at differentiere vores undervisning.</p>
    `
  },

  // 5. Bestyrelse & udvalg
  "bestyrelse-udvalg": {
    slug: "bestyrelse-udvalg",
    title: "Bestyrelse & udvalg",
    summary: "Skolens overordnede ledelse, bestyrelsesmedlemmer samt ForældreForum og Arbejdsudvalget (ARDU).",
    category: "Om skolen",
    hero_image: ["https://assets.auxodev.dk/assets/7e157867-df92-46f8-b5ca-20179d4d9044/olf15.jpg"],
    content: `
      <h2>Bestyrelsen er skolens overordnede ledelse</h2>
      <p>Den er ansvarlig for, at skolens økonomi og drift er i overensstemmelse med vedtægterne, lovgivningen og retsregler i øvrigt. Den vælges på den årlige generalforsamling og består af syv medlemmer og to suppleanter. Bestyrelsen konstituerer sig selv med valg af formand, næstformand, kasserer samt kontaktpersoner til de forskellige udvalg.</p>
      <p>Bestyrelsen holder ca. ti møder om året, hvor også skolelederen og en medarbejderrepræsentant deltager.</p>
      <p>Nedenfor kan du finde forskellige oplysninger vedrørende bestyrelsen:</p>
      <ul>
        <li><strong>Bestyrelsens sammensætning</strong> – Hvem sidder i bestyrelsen (se oversigten herunder).</li>
        <li><strong>Aktuel forretningsorden (pdf)</strong> – Hent bestyrelsens forretningsorden i PDF-format.</li>
      </ul>

      <h2>Bestyrelsens medlemmer</h2>
      <table>
        <thead>
          <tr>
            <th>Navn</th>
            <th>Rolle</th>
            <th>Kontakt</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td><strong>Lars Frello</strong></td>
            <td>Formand</td>
            <td>Tlf: 42 52 06 22 &bull; <a href="mailto:lars@clevercoffee.dk">lars@clevercoffee.dk</a></td>
          </tr>
          <tr>
            <td><strong>Mathilde Sidenius</strong></td>
            <td>Næstformand</td>
            <td>Tlf: 61 65 31 93 &bull; <a href="mailto:mathildesidenius@gmail.com">mathildesidenius@gmail.com</a></td>
          </tr>
          <tr>
            <td><strong>Kristian Radoor</strong></td>
            <td>Kasserer / Økonomiudvalg</td>
            <td><a href="mailto:radoor@gmail.com">radoor@gmail.com</a></td>
          </tr>
          <tr>
            <td><strong>Christian Nielsen</strong></td>
            <td>Suppleant / Økonomiudvalg</td>
            <td><a href="mailto:aalborgvej314@gmail.com">aalborgvej314@gmail.com</a></td>
          </tr>
          <tr>
            <td><strong>Filip Buch Dahl</strong></td>
            <td>Medlem</td>
            <td><a href="mailto:filip@filipdahl.dk">filip@filipdahl.dk</a></td>
          </tr>
          <tr>
            <td><strong>Daniel Stjerne</strong></td>
            <td>Medlem</td>
            <td><a href="mailto:danielstjerne@hotmail.com">danielstjerne@hotmail.com</a></td>
          </tr>
          <tr>
            <td><strong>Franz Skrzipczyk</strong></td>
            <td>Medlem</td>
            <td><a href="mailto:franz.skrz@gmail.com">franz.skrz@gmail.com</a></td>
          </tr>
          <tr>
            <td><strong>Thorbjørn Vishart</strong></td>
            <td>Medlem</td>
            <td><a href="mailto:tv_larsen@hotmail.com">tv_larsen@hotmail.com</a></td>
          </tr>
        </tbody>
      </table>

      <h2>ForældreForum</h2>
      <p>ForældreForum er et udvalg under bestyrelsen, der skal styrke og understøtte forældrenes deltagelse og engagement i Odder lille Friskole. Omdrejningspunktet er forældrefællesskab og den interne kommunikation imellem forældre. Det skal bidrage til at sikre en god indslusning af nye elever og forældre og være med til at forbedre og understøtte forældresamarbejdet både i farvegrupperne og på tværs af klasserne.</p>
      <p>ForældreForum er samtidigt et forum, hvor forældre kan stikke hovederne sammen, diskutere og udveksle erfaringer omkring specifikke emner, der vedrører dagligdagen på Odder Lille Friskole.</p>

      <h2>ARDU – Arbejdsudvalget</h2>
      <p>Arbejdsudvalget er et udvalg af forældre som arrangerer arbejdsweekenderne. Sammen med pedellerne har de overblikket over vedligeholdelsen af skolens bygninger, tilføjelser og forbedring af udearealerne og legepladserne m.m. Udvalget planlægger, hvilke opgaver der skal laves af forældrene på arbejdsdagene i henhold “generelle principper for forældrearbejde”, der vedtages hvert år på generalforsamlingen.</p>
      <p>ARDU sørger for at lægge arbejdsweekenderne ind i skolens kalender, så du har et overblik over hele skoleåret og kan planlægge i god tid, hvilke dage du kan tage. Inden hver arbejdsweekend, sender ARDU en besked rundt til alle forældre, hvor man kan melde sig på en opgave som skal løses på dagen. I samarbejde med forældrene sørger ARDU for at opgaverne bliver udført.</p>
      <p>Så kom til arbejdsweekend på OLF! Der er altid godt humør, frokost i Pavi og godt samarbejde iblandt forældre, hvor der tages fat og skolen bliver plejet.</p>
    `
  },

  // Alias bestyrelse
  "bestyrelse": {
    slug: "bestyrelse",
    title: "Bestyrelse & udvalg",
    summary: "Skolens overordnede ledelse, bestyrelsesmedlemmer samt ForældreForum og Arbejdsudvalget (ARDU).",
    category: "Om skolen",
    hero_image: ["https://assets.auxodev.dk/assets/7e157867-df92-46f8-b5ca-20179d4d9044/olf15.jpg"],
    content: `
      <h2>Bestyrelsen er skolens overordnede ledelse</h2>
      <p>Den er ansvarlig for, at skolens økonomi og drift er i overensstemmelse med vedtægterne, lovgivningen og retsregler i øvrigt. Den vælges på den årlige generalforsamling og består af syv medlemmer og to suppleanter. Bestyrelsen konstituerer sig selv med valg af formand, næstformand, kasserer samt kontaktpersoner til de forskellige udvalg.</p>
      <p>Bestyrelsen holder ca. ti møder om året, hvor også skolelederen og en medarbejderrepræsentant deltager.</p>
      <h2>Bestyrelsens medlemmer</h2>
      <table>
        <thead>
          <tr><th>Navn</th><th>Rolle</th><th>Kontakt</th></tr>
        </thead>
        <tbody>
          <tr><td><strong>Lars Frello</strong></td><td>Formand</td><td>Tlf: 42 52 06 22 &bull; lars@clevercoffee.dk</td></tr>
          <tr><td><strong>Mathilde Sidenius</strong></td><td>Næstformand</td><td>Tlf: 61 65 31 93 &bull; mathildesidenius@gmail.com</td></tr>
          <tr><td><strong>Kristian Radoor</strong></td><td>Kasserer / Økonomiudvalg</td><td>radoor@gmail.com</td></tr>
          <tr><td><strong>Christian Nielsen</strong></td><td>Suppleant / Økonomiudvalg</td><td>aalborgvej314@gmail.com</td></tr>
          <tr><td><strong>Filip Buch Dahl</strong></td><td>Medlem</td><td>filip@filipdahl.dk</td></tr>
          <tr><td><strong>Daniel Stjerne</strong></td><td>Medlem</td><td>danielstjerne@hotmail.com</td></tr>
          <tr><td><strong>Franz Skrzipczyk</strong></td><td>Medlem</td><td>franz.skrz@gmail.com</td></tr>
          <tr><td><strong>Thorbjørn Vishart</strong></td><td>Medlem</td><td>tv_larsen@hotmail.com</td></tr>
        </tbody>
      </table>
      <h2>ForældreForum &amp; ARDU</h2>
      <p>ForældreForum styrker forældrenes engagement og interne dialog. Arbejdsudvalget (ARDU) planlægger og koordinerer de hyggelige arbejdsweekender, hvor skolen vedligeholdes i fællesskab.</p>
    `
  },

  // 6. Vedtægter
  "vedtaegter": {
    slug: "vedtaegter",
    title: "Vedtægter",
    summary: "Skolens formelle vedtægter godkendt af Undervisningsministeriet.",
    category: "Om skolen",
    hero_image: ["https://assets.auxodev.dk/assets/7e157867-df92-46f8-b5ca-20179d4d9044/olf11.jpg"],
    content: `
      <h2>Vedtægter på Odder lille Friskole</h2>
      <p>Odder lille Friskole er som navnet siger en friskole og dermed underlagt Friskoleloven. Den er en selvejende og uafhængig uddannelsesinstitution og skal have et sæt vedtægter, der godkendes af undervisningsministeriet.</p>
      <p>Her kan du hente skolens vedtægter:</p>
      <p><a href="https://assets.auxodev.dk/assets/7e157867-df92-46f8-b5ca-20179d4d9044/vedtaegter-2016.pdf" target="_blank" rel="noopener noreferrer" class="font-bold underline">Hent Vedtægter 2016 (PDF)</a></p>
    `
  },

  // 7. Politikker
  "politikker": {
    slug: "politikker",
    title: "Politikker",
    summary: "Se politikker for trivsel, inklusion og håndtering af børn med særlige udfordringer på OLF.",
    category: "Sådan gør vi",
    hero_image: ["https://assets.auxodev.dk/assets/7e157867-df92-46f8-b5ca-20179d4d9044/olf11.jpg"],
    content: `
      <h2>Politikker på Odder lille Friskole</h2>
      <p>Se alle politikker der gør sig gældende på Odder lille Friskole lige her:</p>
      <ul>
        <li><a href="https://assets.auxodev.dk/assets/7e157867-df92-46f8-b5ca-20179d4d9044/trivselspolitik-pa-olf-til-debat-januar-2019.pdf" target="_blank" rel="noopener noreferrer">Trivselspolitik på OLF (PDF)</a></li>
        <li><a href="https://assets.auxodev.dk/assets/7e157867-df92-46f8-b5ca-20179d4d9044/politikken-og-processen-med-boern-med-saerlige-behov-pa-olf.pdf" target="_blank" rel="noopener noreferrer">Børn med særlige udfordringer / Politikken og processen med børn med særlige behov på OLF (PDF)</a></li>
      </ul>
    `
  },

  // Alias vedtaegter-og-politikker
  "vedtaegter-og-politikker": {
    slug: "vedtaegter-og-politikker",
    title: "Vedtægter & politikker",
    summary: "Vedtægter, trivselspolitik og procedurer for inklusion på Odder Lille Friskole.",
    category: "Praktisk info",
    hero_image: ["https://assets.auxodev.dk/assets/7e157867-df92-46f8-b5ca-20179d4d9044/olf11.jpg"],
    content: `
      <h2>Vedtægter og politikdokumenter</h2>
      <p>Her kan du læse skolens formelle vedtægter, trivselspolitik og procedurer for inklusion og trivsel på Odder Lille Friskole.</p>
      <ul>
        <li><a href="https://assets.auxodev.dk/assets/7e157867-df92-46f8-b5ca-20179d4d9044/vedtaegter-2016.pdf" target="_blank" rel="noopener noreferrer">Vedtægter for Odder Lille Friskole (PDF)</a></li>
        <li><a href="https://assets.auxodev.dk/assets/7e157867-df92-46f8-b5ca-20179d4d9044/trivselspolitik-pa-olf-til-debat-januar-2019.pdf" target="_blank" rel="noopener noreferrer">Trivselspolitik på OLF (PDF)</a></li>
        <li><a href="https://assets.auxodev.dk/assets/7e157867-df92-46f8-b5ca-20179d4d9044/politikken-og-processen-med-boern-med-saerlige-behov-pa-olf.pdf" target="_blank" rel="noopener noreferrer">Politikken og processen med børn med særlige behov på OLF (PDF)</a></li>
      </ul>
    `
  },

  // 8. Evaluering & Tests
  "evaluering-tests": {
    slug: "evaluering-tests",
    title: "Evaluering & Tests",
    summary: "Hvordan vi løbende evaluerer og tester eleverne både fagligt og socialt med udviklingsplaner og støttetilbud.",
    category: "Sådan gør vi",
    hero_image: ["https://assets.auxodev.dk/assets/7e157867-df92-46f8-b5ca-20179d4d9044/olf7.jpg"],
    content: `
      <h2>Evaluering og tests på Odder lille Friskole</h2>
      <p>At være eksamensfri (vi tilbyder ikke 9. kl. afgangseksamen) betyder ikke, at vi ikke evaluerer og tester vores elever på OLF. For selvfølgelig gør vi det. Det er nødvendigt for at få et godt overblik over, hvor eleverne er både fagligt, socialt og personligt i deres skoleforløb – et indblik, som giver tryghed for både elever og forældre.</p>
      <p>Vi bruger forskellige evalueringsværktøjer. På OLF vægter vi de faglige og de sociale kompetencer lige højt, da vores holdning er, at eleverne har brug for begge dele, hvorend de kommer hen i deres uddannelses– og arbejdsforløb. Det stiller også nogle krav til måden at evaluere på. Evalueringer som ikke bare kan gøres op i et tal, men som favner bredere.</p>

      <h2>Udviklingsplan</h2>
      <p>Vi har udviklet et skema til at evaluere eleverne både fagligt, socialt og personligt. Det er et skema, der giver et nemt og godt overblik over eleverns engagement og niveau i alle faglige og sociale sammenhænge.</p>
      <p><a href="https://assets.auxodev.dk/assets/7e157867-df92-46f8-b5ca-20179d4d9044/sc-mf335-1190228121000.pdf" target="_blank" rel="noopener noreferrer">Se oversigt over Evaluering &amp; tests (PDF)</a></p>
      <p>Dette skema vil sammen med evt. tests eller evalueringsprøver, blive udgangspunkt for forældresamtalerne to gange om året. Læreren vil ud fra dette kunne udtale sig om elevens niveau, samt indsatsområder for kommende periode.</p>

      <h2>Tests</h2>
      <p>Hvis ovenstående evalueringer giver anledning til faglig bekymring, har vi forskellige tests vi bruger, for mere specifikt at finde ud af, hvor der skal sættes ind.</p>

      <h2>Støtteundervisning på OLF</h2>
      <p>På Odder lille Friskole har vi to forskellige tiltag til de af vores elever, der måtte have brug for det. Det ene er et internt tilbud om læse- og matematikløft. Det andet er specialundervisning. Det er delt op på følgende måde:</p>
      <ul>
        <li><strong>Læse- og matematik-løft:</strong> Dette er ikke specialundervisning i traditionel forstand, men er tiltænkt de børn, hvor det skønnes, at et ekstra læse-/matematik-”boost” vil hjælpe dem godt på vej og give dem endnu bedre muligheder for at følge normal undervisning.</li>
        <li><strong>Specialundervisning:</strong> Som led i inklusionstanken har vi specialundervisning, hvor vi skønner, behovet er til stede. Specialundervisningen er noget, vi tilbyder og planlægger internt.</li>
      </ul>
      <p>Hvis der er formodning om, at en elev vil have behov for yderligere specielundervisning, dvs. hjælp i 9 timer eller mere om ugen, vil eleven blive testet. Herefter vil eleven, via skolens koordineringskonference med en psykolog, blive indstillet via PPR. Derefter har skolen mulighed for at søge om midler til det.</p>
    `
  },

  // 9. Fælles mål
  "faelles-maal": {
    slug: "faelles-maal",
    title: "Fælles mål",
    summary: "OLF følger ministeriets fælles mål og sikrer, at undervisningen som minimum står mål med kravene i folkeskolen.",
    category: "Sådan gør vi",
    hero_image: ["https://assets.auxodev.dk/assets/7e157867-df92-46f8-b5ca-20179d4d9044/2.jpg"],
    content: `
      <h2>Kompetencemål</h2>
      <p>Odder lille Friskole følger ministeriets fælles mål og tager, i forbindelse med planlægningen af undervisningen, afsæt i de dertil hørende læseplaner. Målene er med til at sikre, at vi som minimum står mål med de krav som almindeligvis forventes i folkeskolen.</p>

      <h2>UU-Vejledning</h2>
      <p>På Odder lille Friskole samarbejder vi med UU-vejledningen i Skanderborg – Odder. Der er kompetente kræfter, der hjælper vores i elever i 7.-9. klasse i forhold til ønsker og muligheder efter 9 klasse.</p>
    `
  },

  // 10. Klasser & Grupper
  "klasser-grupper": {
    slug: "klasser-grupper",
    title: "Klasser & Grupper",
    summary: "Farvegrupper, storgrupper (Stjerner, Drabanter, Planeter, Satellitter, Kometer) og familiegrupper.",
    category: "Sådan gør vi",
    hero_image: ["https://assets.auxodev.dk/assets/7e157867-df92-46f8-b5ca-20179d4d9044/olf10.jpg"],
    content: `
      <h2>Farvegrupper, familiegrupper og storgrupper</h2>
      <p>Når man starter på OLF er der tre grupper man skal forholde sig til.</p>

      <h2>Farvegrupper</h2>
      <p>Hver klasse har sin egen farve (grøn, gul, lilla, pink osv.). Når der starter en ny 0. klasse op, så arver den farven fra den afgående 9. klasse. Det er rigtig hyggeligt når der både er en lille stjerne-blå og en blå klasse på skolen. Det binder de aller yngste og de ældste sammen og skaber et godt sammenhold. En klasse beholder sin farve gennem hele skoleforløbet.</p>

      <h2>Storgrupper</h2>
      <p>Naboklasserne arbejder tæt sammen i storgrupper. 0. og 1. klasse er en storgruppe, 2. kl. og 3. kl. er en storgruppe osv. Storgrupperne har faste, aldersbestemte navne:</p>
      <ul>
        <li><strong>Stjerner:</strong> 0. og 1. klasse</li>
        <li><strong>Drabanter:</strong> 2. og 3. klasse</li>
        <li><strong>Planeter:</strong> 4. og 5. klasse</li>
        <li><strong>Satellitter:</strong> 6. og 7. klasse</li>
        <li><strong>Kometer:</strong> 8. og 9. klasse</li>
      </ul>
      <p>Det meste af undervisningen foregår i ens farvegruppe (klassen) og storgrupper. Der veksles mellem perioder med skemauger og projektuger. Dette fremgår af årskalenderen.</p>
      <p>I skemaugerne arbejdes der med de almindelige skolefag. I projektugerne arbejdes der tværfagligt med forskellige emner.</p>

      <h2>Familiegrupper</h2>
      <p>Alle børn er med i en familiegruppe. Det er grupper på ca. 16-18 børn fordelt på alle årgange.</p>
      <p>Familiegruppen mødes en time en gang om ugen, samt en hel dag måneden fra 8.15 – 13. Disse dage er planlagt med et udpræget socialt- og fællesskabende indhold. Grupperne kan bl.a. tage på tur, stå for flere forskellige traditionelle arrangementer f.eks. fodboldturnering, Melodi Grand Prix, fastelavnsfest osv. Familiegruppernes formål er, at de store og små kommer til at kende hinanden, blive trygge ved hinanden og kan lege på tværs af aldre. Dette skaber en større trivsel og mindsker mobning iblandt eleverne.</p>
      <p>Familiegrupperne dannes en gang årligt.</p>
    `
  },

  // 11. Læseplaner
  "laeseplaner": {
    slug: "laeseplaner",
    title: "Læseplaner",
    summary: "Oversigt over fag, tværfaglighed, KIF-valgfag og læseplaner fra børnehaveklasse til 9. klasse.",
    category: "Sådan gør vi",
    hero_image: ["https://assets.auxodev.dk/assets/7e157867-df92-46f8-b5ca-20179d4d9044/2.jpg"],
    content: `
      <h2>Vores læseplaner</h2>
      <p>På OLF har vi fokus på, at nå de samme nationale mål for elever som folkeskolen, således de føler sig klædt på til deres videre rejse med et afgangsbevis efter 9. klasse. Vi lægger stor vægt på tværfaglighed og projektarbejde, da det danner eleverne på en måde hvor de ser en større sammenhæng mellem forskellige faglige tilgange til en problemstilling.</p>
      <p>I indskolingen har vi dansk, matematik, idræt, billedkunst, musik, natur/teknologi og engelsk. Og i 2. klasse begynder eleverne til svømning. Det har de til og med 5. klasse.</p>
      <p>I mellemtrin begynder håndværk og design at komme på skemaet samt historie. Og i 6. klasse begynder vores elever at lære tysk.</p>
      <p>KIF er vores tilvalgsfag hvor eleverne kan komme i dybden med forskellige emner og praktiske færdigheder. Det kan for eksempel vær madkundskab, håndværk og design, kunst og kultur, idræt o.a.</p>
      <p>I udskolingen dykker eleverne ned i geografi, biologi, fysik/kemi samfundsvidenskab og religion. Og de elever som skal konfirmeres i 8. klasse, får konfirmationsforberedelse efter uge 43.</p>
      <p>På tværs af alle årgange har vi projekter og familiegrupper som eleverne deltager aktivt. Og der er afsat en ugentlig lektion til familiegruppen hos alle.</p>

      <h2>Fagoversigt og læseplaner</h2>
      <ul>
        <li><strong>Billedkunst:</strong> Fællesmål, læseplan og vejledning</li>
        <li><strong>Biologi:</strong> Fællesmål, læseplan og vejledning</li>
        <li><strong>Dansk:</strong> Fællesmål, læseplan og vejledning</li>
        <li><strong>Dansk som andetsprog:</strong> Fællesmål, læseplan og vejledning</li>
        <li><strong>Engelsk:</strong> Fællesmål, læseplan og vejledning</li>
        <li><strong>Fysik/kemi:</strong> Fællesmål, læseplan og vejledning</li>
        <li><strong>Geografi:</strong> Fællesmål, læseplan og vejledning</li>
        <li><strong>Historie:</strong> Fællesmål, læseplan og vejledning</li>
        <li><strong>Håndværk og design:</strong> Fællesmål, læseplan og vejledning</li>
        <li><strong>Idræt:</strong> Fællesmål, læseplan og vejledning</li>
        <li><strong>Matematik:</strong> Fællesmål, læseplan og vejledning</li>
        <li><strong>Musik:</strong> Fællesmål, læseplan og vejledning</li>
        <li><strong>Samfundsfag:</strong> Fællesmål, læseplan og vejledning</li>
        <li><strong>Natur/teknik:</strong> Fællesmål, læseplan og vejledning</li>
        <li><strong>Tysk:</strong> Fællesmål, læseplan og vejledning</li>
        <li><strong>Sundhed og seksualundervisning:</strong> Fællesmål, læseplan og vejledning</li>
        <li><strong>Børnehaveklasse:</strong> Fællesmål, læseplan og vejledning</li>
        <li><strong>Fritter (SFO):</strong> Fritter pædagogiske mål og rammer</li>
      </ul>
    `
  },

  // 12. Traditioner
  "traditioner": {
    slug: "traditioner",
    title: "Traditioner",
    summary: "Morgensang, Samfundsleg, lejrskoler, forårsbasar, Sankt Hans og årlige traditioner, der samler skolen.",
    category: "Sådan gør vi",
    hero_image: ["https://assets.auxodev.dk/assets/7e157867-df92-46f8-b5ca-20179d4d9044/olf17_688ac7b9.jpg"],
    gallery_images: [
      "https://assets.auxodev.dk/assets/7e157867-df92-46f8-b5ca-20179d4d9044/olf17_688ac7b9.jpg",
      "https://assets.auxodev.dk/assets/7e157867-df92-46f8-b5ca-20179d4d9044/olf9_6eab3116.jpg",
      "https://assets.auxodev.dk/assets/7e157867-df92-46f8-b5ca-20179d4d9044/olf8_fa98eed1.jpg",
      "https://assets.auxodev.dk/assets/7e157867-df92-46f8-b5ca-20179d4d9044/olf10_c95115f1.jpg",
      "https://assets.auxodev.dk/assets/7e157867-df92-46f8-b5ca-20179d4d9044/olf12_2ef0594f.jpg",
      "https://assets.auxodev.dk/assets/7e157867-df92-46f8-b5ca-20179d4d9044/olf2_b5cbf2ac.jpg"
    ],
    content: `
      <h2>Fællesting i hverdagen</h2>
      <p>På OLF er der fælles morgensang og fællesmøde for alle børn og lærere en gang om ugen. Skolens SFO (Fritteren) er åben for alle børn uanset alder, og bliver derved også brugt af de større børn.</p>
      
      <figure class="my-6 overflow-hidden rounded-2xl border border-[#d9e5d4] bg-[#eef4e6]">
        <img src="https://assets.auxodev.dk/assets/7e157867-df92-46f8-b5ca-20179d4d9044/olf17_688ac7b9.jpg" alt="Morgensang og fællesskab på OLF" class="w-full h-auto object-cover max-h-[460px]" />
      </figure>

      <h2>Samfundsleg</h2>
      <p>Hvert efterår er der en uge med samfundsleg. Hele skolen omdannes til et minisamfund med virksomheder, butikker, bank, og meget mere. Nogle af virksomhederne er restauranter, hvor børnene og de mange besøgende forældre kan købe mad for særlige “OLF-penge”. De ældste børn planlægger butikslegen sammen med deres lærere. Samfundslegen giver børnene en legende mulighed for at opleve hvordan et samfund fungerer ved hjælp af økonomistyring, jobansvar og bidrag til et fællesskab på forskellige måder. Der er både politi, en regering, butikker og restauranter og endda en redaktion herunder også journalister som udgiver en OLF-avis og laver samfundsnyheder.</p>

      <div class="my-6 grid grid-cols-1 sm:grid-cols-2 gap-4">
        <div class="overflow-hidden rounded-2xl border border-[#d9e5d4] bg-[#eef4e6] aspect-4/3">
          <img src="https://assets.auxodev.dk/assets/7e157867-df92-46f8-b5ca-20179d4d9044/olf9_6eab3116.jpg" alt="Samfundsleg på OLF" class="w-full h-full object-cover" />
        </div>
        <div class="overflow-hidden rounded-2xl border border-[#d9e5d4] bg-[#eef4e6] aspect-4/3">
          <img src="https://assets.auxodev.dk/assets/7e157867-df92-46f8-b5ca-20179d4d9044/olf8_fa98eed1.jpg" alt="Minisamfund og OLF-penge" class="w-full h-full object-cover" />
        </div>
      </div>

      <h2>Andre traditioner</h2>
      <ul>
        <li><strong>Juleværksteder</strong> i december som er arrangeret af de ældste elever.</li>
        <li><strong>Fodboldturnering</strong>, hvor familiegrupperne spiller mod hinanden.</li>
        <li><strong>Motionsdag</strong> den sidste dag inden efterårsferien.</li>
        <li><strong>Lejrskole:</strong> Hvert andet år er børnene på lejr i storgrupper og hvert andet er de afsted på fælleslejr. Vi har blandt andet været på Tunø, i Skanderborg, Juelsminde og de ældste i København.</li>
        <li><strong>9. klasse</strong> er på udlandsrejse i slutningen af skoleåret som de selv planlægger og tjener penge til.</li>
      </ul>

      <div class="my-6 grid grid-cols-1 sm:grid-cols-2 gap-4">
        <div class="overflow-hidden rounded-2xl border border-[#d9e5d4] bg-[#eef4e6] aspect-4/3">
          <img src="https://assets.auxodev.dk/assets/7e157867-df92-46f8-b5ca-20179d4d9044/olf10_c95115f1.jpg" alt="Lejrskole og fællesture på OLF" class="w-full h-full object-cover" />
        </div>
        <div class="overflow-hidden rounded-2xl border border-[#d9e5d4] bg-[#eef4e6] aspect-4/3">
          <img src="https://assets.auxodev.dk/assets/7e157867-df92-46f8-b5ca-20179d4d9044/olf12_2ef0594f.jpg" alt="Fælleslejr og lejrskoler" class="w-full h-full object-cover" />
        </div>
      </div>

      <h2>Arrangementer for forældre</h2>
      <ul>
        <li><strong>Første skoledag i august:</strong> Flaget hejses, vi klapper alle eleverne ind og synger OLF-sangen.</li>
        <li><strong>Markedsdag:</strong> Byder på boder med lækkerier, spændende ting og sjove oplevelser.</li>
        <li><strong>Skolefesten i efteråret:</strong> Masser af farver, musik og et tema.</li>
        <li><strong>Juleafslutning:</strong> Luciaoptog og hvor hele skolen samles om en dans rundt om juletræet og ønsker hinanden en god jul inden ferien starter.</li>
        <li><strong>Sankt Hans i Vitaparken:</strong> Arrangeret af skolens 7. klasse i samarbejde med deres forældre. Et kæmpe hit i Odder, da festen tilgodeser børnefamilier med de helt små. Bålet tændes tidligt, madboder, ansigtsmaling, picnic på græsplænen og masser af hygge.</li>
        <li><strong>Sommerafslutning:</strong> Hvor vi kan se de ældstes afslutningsprojekt, opleve eleverne optræde med musik og sang og spise aftensmad sammen med hinanden.</li>
      </ul>

      <figure class="my-6 overflow-hidden rounded-2xl border border-[#d9e5d4] bg-[#eef4e6]">
        <img src="https://assets.auxodev.dk/assets/7e157867-df92-46f8-b5ca-20179d4d9044/olf2_b5cbf2ac.jpg" alt="Forældrearrangementer og fællesskab på OLF" class="w-full h-auto object-cover max-h-[460px]" />
      </figure>
    `
  },

  // Alias traditioner-og-lejre
  "traditioner-og-lejre": {
    slug: "traditioner-og-lejre",
    title: "Traditioner",
    summary: "Morgensang, Samfundsleg, lejrskoler, forårsbasar, Sankt Hans og årlige traditioner, der samler skolen.",
    category: "Hverdagen",
    hero_image: ["https://assets.auxodev.dk/assets/7e157867-df92-46f8-b5ca-20179d4d9044/olf17_688ac7b9.jpg"],
    gallery_images: [
      "https://assets.auxodev.dk/assets/7e157867-df92-46f8-b5ca-20179d4d9044/olf17_688ac7b9.jpg",
      "https://assets.auxodev.dk/assets/7e157867-df92-46f8-b5ca-20179d4d9044/olf9_6eab3116.jpg",
      "https://assets.auxodev.dk/assets/7e157867-df92-46f8-b5ca-20179d4d9044/olf8_fa98eed1.jpg",
      "https://assets.auxodev.dk/assets/7e157867-df92-46f8-b5ca-20179d4d9044/olf10_c95115f1.jpg",
      "https://assets.auxodev.dk/assets/7e157867-df92-46f8-b5ca-20179d4d9044/olf12_2ef0594f.jpg",
      "https://assets.auxodev.dk/assets/7e157867-df92-46f8-b5ca-20179d4d9044/olf2_b5cbf2ac.jpg"
    ],
    content: `
      <h2>Fællesting i hverdagen</h2>
      <p>På OLF er der fælles morgensang og fællesmøde for alle børn og lærere en gang om ugen. Skolens SFO (Fritteren) er åben for alle børn uanset alder, og bliver derved også brugt af de større børn.</p>
      
      <figure class="my-6 overflow-hidden rounded-2xl border border-[#d9e5d4] bg-[#eef4e6]">
        <img src="https://assets.auxodev.dk/assets/7e157867-df92-46f8-b5ca-20179d4d9044/olf17_688ac7b9.jpg" alt="Morgensang og fællesskab på OLF" class="w-full h-auto object-cover max-h-[460px]" />
      </figure>

      <h2>Samfundsleg</h2>
      <p>Hvert efterår er der en uge med samfundsleg. Hele skolen omdannes til et minisamfund med virksomheder, butikker, bank, og meget mere. Nogle af virksomhederne er restauranter, hvor børnene og de mange besøgende forældre kan købe mad for særlige “OLF-penge”. De ældste børn planlægger butikslegen sammen med deres lærere. Samfundslegen giver børnene en legende mulighed for at opleve hvordan et samfund fungerer ved hjælp af økonomistyring, jobansvar og bidrag til et fællesskab på forskellige måder. Der er både politi, en regering, butikker og restauranter og endda en redaktion herunder også journalister som udgiver en OLF-avis og laver samfundsnyheder.</p>

      <div class="my-6 grid grid-cols-1 sm:grid-cols-2 gap-4">
        <div class="overflow-hidden rounded-2xl border border-[#d9e5d4] bg-[#eef4e6] aspect-4/3">
          <img src="https://assets.auxodev.dk/assets/7e157867-df92-46f8-b5ca-20179d4d9044/olf9_6eab3116.jpg" alt="Samfundsleg på OLF" class="w-full h-full object-cover" />
        </div>
        <div class="overflow-hidden rounded-2xl border border-[#d9e5d4] bg-[#eef4e6] aspect-4/3">
          <img src="https://assets.auxodev.dk/assets/7e157867-df92-46f8-b5ca-20179d4d9044/olf8_fa98eed1.jpg" alt="Minisamfund og OLF-penge" class="w-full h-full object-cover" />
        </div>
      </div>

      <h2>Andre traditioner &amp; lejrskoler</h2>
      <ul>
        <li><strong>Juleværksteder</strong> i december som er arrangeret af de ældste elever.</li>
        <li><strong>Fodboldturnering</strong>, hvor familiegrupperne spiller mod hinanden.</li>
        <li><strong>Motionsdag</strong> den sidste dag inden efterårsferien.</li>
        <li><strong>Lejrskole:</strong> Hvert andet år er børnene på lejr i storgrupper og hvert andet er de afsted på fælleslejr. Vi har blandt andet været på Tunø, i Skanderborg, Juelsminde og de ældste i København.</li>
        <li><strong>9. klasse</strong> er på udlandsrejse i slutningen af skoleåret som de selv planlægger og tjener penge til.</li>
      </ul>

      <div class="my-6 grid grid-cols-1 sm:grid-cols-2 gap-4">
        <div class="overflow-hidden rounded-2xl border border-[#d9e5d4] bg-[#eef4e6] aspect-4/3">
          <img src="https://assets.auxodev.dk/assets/7e157867-df92-46f8-b5ca-20179d4d9044/olf10_c95115f1.jpg" alt="Lejrskole og fællesture på OLF" class="w-full h-full object-cover" />
        </div>
        <div class="overflow-hidden rounded-2xl border border-[#d9e5d4] bg-[#eef4e6] aspect-4/3">
          <img src="https://assets.auxodev.dk/assets/7e157867-df92-46f8-b5ca-20179d4d9044/olf12_2ef0594f.jpg" alt="Fælleslejr og lejrskoler" class="w-full h-full object-cover" />
        </div>
      </div>

      <h2>Arrangementer for forældre</h2>
      <ul>
        <li><strong>Første skoledag i august:</strong> Flaget hejses, vi klapper alle eleverne ind og synger OLF-sangen.</li>
        <li><strong>Markedsdag:</strong> Byder på boder med lækkerier, spændende ting og sjove oplevelser.</li>
        <li><strong>Skolefesten i efteråret:</strong> Masser af farver, musik og et tema.</li>
        <li><strong>Juleafslutning:</strong> Luciaoptog og dans om juletræet.</li>
        <li><strong>Sankt Hans i Vitaparken:</strong> Arrangeret af skolens 7. klasse i samarbejde med forældrene.</li>
        <li><strong>Sommerafslutning:</strong> Med afslutningsprojekt, musik, sang og fællesspisning.</li>
      </ul>

      <figure class="my-6 overflow-hidden rounded-2xl border border-[#d9e5d4] bg-[#eef4e6]">
        <img src="https://assets.auxodev.dk/assets/7e157867-df92-46f8-b5ca-20179d4d9044/olf2_b5cbf2ac.jpg" alt="Forældrearrangementer og fællesskab på OLF" class="w-full h-auto object-cover max-h-[460px]" />
      </figure>
    `
  },

  // 13. Tilsyn
  "tilsyn": {
    slug: "tilsyn",
    title: "Tilsyn",
    summary: "Forældrenes overordnede tilsyn og erklæringer fra den eksterne forældrevalgte tilsynsførende.",
    category: "Sådan gør vi",
    hero_image: ["https://assets.auxodev.dk/assets/7e157867-df92-46f8-b5ca-20179d4d9044/olf7.jpg"],
    content: `
      <h2>Tilsyn på Odder lille Friskole</h2>
      <p>Ifølge Friskoleloven og skolens vedtægter er det forældrene, der har det overordnede tilsyn med skolen.</p>
      <p>Desuden findes “det eksterne forældrevalgte tilsyn”, hvor forældrene vælger en tilsynsførende, der ikke har tilknytning til skolen. Denne besøger skolen flere gange i løbet af skoleåret og laver en skriftlig erklæring.</p>
      <p>Tilsynet skal bl.a. sikre, “at undervisningen står mål med, hvad der kræves i folkeskolen og være med til at forberede eleverne til at leve i et samfund med frihed og folkestyre”.</p>
      <p>Nedenfor findes den tilsynsførendes erklæringer fra de seneste år:</p>
      <ul>
        <li><a href="https://assets.auxodev.dk/assets/7e157867-df92-46f8-b5ca-20179d4d9044/tilsyn.pdf" target="_blank" rel="noopener noreferrer">Tilsynserklæring 2024-2025 (PDF)</a></li>
        <li><a href="https://assets.auxodev.dk/assets/7e157867-df92-46f8-b5ca-20179d4d9044/tilsyn-erklaering-23-24.pdf" target="_blank" rel="noopener noreferrer">Tilsynserklæring 2023-2024 (PDF)</a></li>
        <li><a href="https://assets.auxodev.dk/assets/7e157867-df92-46f8-b5ca-20179d4d9044/tilsynsrapport-22-23.pdf" target="_blank" rel="noopener noreferrer">Tilsynserklæring 2022-2023 (PDF)</a></li>
        <li><a href="https://assets.auxodev.dk/assets/7e157867-df92-46f8-b5ca-20179d4d9044/statens-afsluttende-tilsynsrapport.pdf" target="_blank" rel="noopener noreferrer">Statens afsluttende tilsynsrapport (PDF)</a></li>
      </ul>
    `
  },

  // Alias tilsyn-og-evaluering
  "tilsyn-og-evaluering": {
    slug: "tilsyn-og-evaluering",
    title: "Tilsyn og evaluering",
    summary: "Tilsynsrapporter, evalueringsrapporter og UVM-dokumenter.",
    category: "Praktisk info",
    hero_image: ["https://assets.auxodev.dk/assets/7e157867-df92-46f8-b5ca-20179d4d9044/olf7.jpg"],
    content: `
      <h2>Officielle dokumenter og tilsyn</h2>
      <p>Som fri grundskole er Odder Lille Friskole underlagt eksternt tilsyn af en certificeret tilsynsførende samt Ministeriet for Børn og Undervisning. Tilsynet sikrer, at undervisningen står mål med, hvad der almindeligvis kræves i folkeskolen.</p>
      <ul>
        <li><a href="https://assets.auxodev.dk/assets/7e157867-df92-46f8-b5ca-20179d4d9044/tilsyn.pdf" target="_blank" rel="noopener noreferrer">Tilsynserklæring 2024-2025 (PDF)</a></li>
        <li><a href="https://assets.auxodev.dk/assets/7e157867-df92-46f8-b5ca-20179d4d9044/tilsyn-erklaering-23-24.pdf" target="_blank" rel="noopener noreferrer">Tilsynserklæring 2023-2024 (PDF)</a></li>
        <li><a href="https://assets.auxodev.dk/assets/7e157867-df92-46f8-b5ca-20179d4d9044/tilsynsrapport-22-23.pdf" target="_blank" rel="noopener noreferrer">Tilsynserklæring 2022-2023 (PDF)</a></li>
        <li><a href="https://assets.auxodev.dk/assets/7e157867-df92-46f8-b5ca-20179d4d9044/statens-afsluttende-tilsynsrapport.pdf" target="_blank" rel="noopener noreferrer">Statens afsluttende tilsynsrapport (PDF)</a></li>
        <li><a href="https://assets.auxodev.dk/assets/7e157867-df92-46f8-b5ca-20179d4d9044/evalueringsrapport-af-olf-2023.pdf" target="_blank" rel="noopener noreferrer">Evalueringsrapport af OLF 2023 (PDF)</a></li>
        <li><a href="https://assets.auxodev.dk/assets/7e157867-df92-46f8-b5ca-20179d4d9044/uvm.pdf" target="_blank" rel="noopener noreferrer">Læs UVM her (PDF)</a></li>
        <li><a href="https://assets.auxodev.dk/assets/7e157867-df92-46f8-b5ca-20179d4d9044/sc-mf335-1190228121000.pdf" target="_blank" rel="noopener noreferrer">Evaluering &amp; tests (PDF)</a></li>
      </ul>
    `
  },

  // 14. Undervisningsmiljø vurdering
  "undervisningsmiljoe-vurdering": {
    slug: "undervisningsmiljoe-vurdering",
    title: "Undervisningsmiljø vurdering",
    summary: "Trivselsmålinger for 0.-3. klassetrin og 4.-9. klassetrin samt UVM-vurdering.",
    category: "Sådan gør vi",
    hero_image: ["https://assets.auxodev.dk/assets/7e157867-df92-46f8-b5ca-20179d4d9044/olf8.jpg"],
    content: `
      <h2>Trivselsmålinger for 0.-3. klassetrin og 4.-9. klassetrin</h2>
      <p>Nedenfor kan du se vores undervisningsmiljø vurdering i PDF-format:</p>
      <ul>
        <li><a href="https://assets.auxodev.dk/assets/7e157867-df92-46f8-b5ca-20179d4d9044/trivselsundersoegelse-2020-0-3-klasse-komprimeret.pdf" target="_blank" rel="noopener noreferrer">0.-3. klassetrin – Trivselsundersøgelse (PDF)</a></li>
        <li><a href="https://assets.auxodev.dk/assets/7e157867-df92-46f8-b5ca-20179d4d9044/trivselsundersoegelse-2020-4-9-klasse-komprimeret.pdf" target="_blank" rel="noopener noreferrer">4.-9. klassetrin – Trivselsundersøgelse (PDF)</a></li>
      </ul>

      <h2>Undervisningsmiljø vurdering</h2>
      <p><a href="https://assets.auxodev.dk/assets/7e157867-df92-46f8-b5ca-20179d4d9044/uvm.pdf" target="_blank" rel="noopener noreferrer">Læs UVM her (PDF)</a></p>
    `
  },

  // 15. Nøgletal
  "noegletal": {
    slug: "noegletal",
    title: "Nøgletal",
    summary: "Statistiske oplysninger hos Undervisningsministeriet om OLF-elevers overgang til ungdomsuddannelserne.",
    category: "Sådan gør vi",
    hero_image: ["https://assets.auxodev.dk/assets/7e157867-df92-46f8-b5ca-20179d4d9044/olf8.jpg"],
    content: `
      <h2>Nøgletal på Odder lille Friskole</h2>
      <p>Statistiske oplysninger hos Undervisningsministeriet om OLF-elevers overgang til ungdomsuddannelserne.</p>
      <p>Som prøvefri friskole vurderes vores elever gennem grundige udtalelser og afslutningsprojekter. Eleverne fortsætter ubesværet på gymnasiale uddannelser (via optagelsesprøve), erhvervsuddannelser, efterskoler og andre ungdomsuddannelser i tæt samarbejde med UU-vejledningen.</p>
    `
  },

  // 16. Evaluering af skolen
  "evaluering-af-skolen": {
    slug: "evaluering-af-skolen",
    title: "Evaluering af skolen",
    summary: "Systematisk evaluering af skolens samlede undervisningstilbud hvert andet år.",
    category: "Sådan gør vi",
    hero_image: ["https://assets.auxodev.dk/assets/7e157867-df92-46f8-b5ca-20179d4d9044/olf7.jpg"],
    content: `
      <h2>Evaluering af Odder lille Friskole</h2>
      <p>Hvert andet år ser vi samlet på skolens undervisningstilbud for at sikre, at undervisningen står mål med folkeskolens krav og mål. Når vi systematisk evaluerer, sikrer vi, at vi kommer omkring alle delmål i skolens undervisningstilbud, og derved forholder os kritisk til justeringer og ændringer.</p>
      <p><a href="https://assets.auxodev.dk/assets/7e157867-df92-46f8-b5ca-20179d4d9044/evalueringsrapport-af-olf-2023.pdf" target="_blank" rel="noopener noreferrer">Hent Evalueringsrapport 2023 (PDF)</a></p>
    `
  },

  // 17. Elev
  "elev": {
    slug: "elev",
    title: "Elev på OLF",
    summary: "Forventninger til elever på OLF: medansvar for undervisningsmiljøet, fællesskab, mobilfri skole og mødestabilitet.",
    category: "På OLF",
    hero_image: ["https://assets.auxodev.dk/assets/7e157867-df92-46f8-b5ca-20179d4d9044/2.jpg"],
    content: `
      <h2>At være elev på OLF</h2>
      <p>For at skoledagen og undervisningen kan forløbe godt, og alle får mest muligt, socialt og fagligt, ud af at gå på OLF, har vi fra skolens side også nogle forventninger til vores elever.</p>

      <h2>Som OLF-elev er det en selvfølge at:</h2>
      <ul>
        <li><strong>Du er medansvarlig for, at undervisningsmiljøet er godt.</strong> Selvfølgelig gør du dit til, at der er den nødvendige ro i klassen. Du har respekt for dine kammerater, læreren, vikarer og undervisningen. Selvfølgelig larmer du ikke, du forstyrrer ikke, du kommenterer ikke negativt, ”griner af”, ”har gang i alt muligt andet”. Og du ved, at du ”markerer”, når du gerne vil sige noget.</li>
        <li><strong>Du er en del af ansvaret for fællesskabet på OLF.</strong> Du tager medansvar og er med til at gøre os endnu stærkere.</li>
        <li><strong>Du er mødestabil.</strong> Det er selvklart at du møder til tiden og går ikke før tid, med mindre andet er aftalt.</li>
        <li><strong>Du forlader ikke skolens grund</strong> i undervisningstiden, med mindre andet er aftalt.</li>
        <li><strong>Du kommer ind, når klokken ringer</strong>, og sidder klar til undervisning.</li>
        <li><strong>Du er udhvilet</strong> – også for din egen skyld.</li>
        <li><strong>Du har lavet dine hjemmeopgaver.</strong> Og det er klart at du når de deadlines der er med mindre andet er aftalt med læreren.</li>
        <li><strong>Du deltager aktivt</strong> og engageret i undervisningen.</li>
        <li><strong>Du ikke bruger din mobil i skoletiden.</strong> Den bliver låst inde i et mobilskab, og du får den igen, inden du går hjem.</li>
        <li><strong>Du tjekker elevintra dagligt.</strong> Du bliver opdateret mht. lektier, ture, ændringer m.m.</li>
      </ul>

      <p>Som elev på OLF får du selvfølgelig en god morgenmad og madpakke med, så hjernen og maven har noget at arbejde med. Alt sammen for at skabe de bedste rammer for undervisningen, så din krop har det godt, du har masser af energi og det bliver et trygt og godt skoleforløb for alle.</p>
    `
  },

  // 18. Udlandsrejse
  "udlandsrejse": {
    slug: "udlandsrejse",
    title: "Udlandsrejse",
    summary: "I 9. klasse rejser eleverne 12 dage til udlandet på en studietur, de selv har sparet op til og planlagt.",
    category: "På OLF",
    hero_image: ["https://assets.auxodev.dk/assets/7e157867-df92-46f8-b5ca-20179d4d9044/3_0040c910.jpg"],
    gallery_images: [
      "https://assets.auxodev.dk/assets/7e157867-df92-46f8-b5ca-20179d4d9044/3_0040c910.jpg",
      "https://assets.auxodev.dk/assets/7e157867-df92-46f8-b5ca-20179d4d9044/4_f29fa4ce.jpg",
      "https://assets.auxodev.dk/assets/7e157867-df92-46f8-b5ca-20179d4d9044/5_eba16670.jpg",
      "https://assets.auxodev.dk/assets/7e157867-df92-46f8-b5ca-20179d4d9044/6_a667a3eb.jpg",
      "https://assets.auxodev.dk/assets/7e157867-df92-46f8-b5ca-20179d4d9044/2_b1a83d47.jpg",
      "https://assets.auxodev.dk/assets/7e157867-df92-46f8-b5ca-20179d4d9044/olf11_3de1d9f9.jpg"
    ],
    content: `
      <h2>Udlandsrejse for 9. klasserne på OLF</h2>
      <p>I 9. klasse rejser vi i 12 dage til udlandet. I 5. – 6. klasse begynder eleverne at samle penge til klassekassen, som de så rejser for.</p>
      <p>Eleverne på Odder lille Friskole har snart været overalt i verden, og på 2. sal på skolen hænger et stort verdenskort, som viser de forskellige destinationer. For eksempel, i 2013 rejste Lilla til Thailand, i 2014 var Blå i Vietnam og i 2015 var Pink i Sri Lanka.</p>
      <p>Det er bestemt ikke bare en badeferie. Rejsen er en del af undervisningen og er særdeles lærerig for eleverne. De møder nye kulturer, øver sig i sprog, lærer historie om landet og mærker oplevelsen af at være på rejse – med alt hvad det indebærer.</p>

      <h2>Hvorfor rejser vi?</h2>
      <p>At tage på udlandsrejse i 9. klasse er en værdifuld oplevelse. Det er en vigtig del af skolens værdisæt og bidrager til flere centrale aspekter af elevernes udvikling og dannelse. Bl.a. bidrager udlandsrejsen til kulturel forståelse, global bevidsthed, personlig udvikling, selvstændighed og et fagligt- og uddannelsesmæssigt udbytte, hvor eleverne lærer om historien, samfundet og naturen i det land, hvor rejsen går til. Det forbereder eleverne på livet efter skolen både som medborgere i et globalt samfund og som selvstændige individer med en bred horisont. Selvstændige stærke individer der kan tage medansvar og arbejde målorienteret.</p>

      <h2>Udgangspunktet er fællesskab og ansvar</h2>
      <p>Som en del af skolens værdigrundlag lægger vi vægt på fællesskab, ansvar og aktiv deltagelse i skolens aktiviteter. Dette gælder også for de fundraisingaktiviteter, der bliver arrangeret i forhold til udlandsrejsen i 9. klasse. Vi anerkender, at der kan være individuelle årsager til, at enkelte elever ikke har mulighed for at deltage i selve rejsen, men vi opfordrer alligevel til, at alle elever engagerer sig i de aktiviteter, der knytter sig hertil.</p>
      <p>Fundraising-aktiviteter vurderes at være alment dannende og handler om mere end blot indtjening til udlandsrejsen. Det indebærer også udviklingen af faglige kundskaber og personlige og sociale værdier som er essentielle for at være en ansvarlig og engageret deltager i samfundet.</p>
      <p>Eleverne lærer både om budgettering og organisering af projekter der styrker matematiske og organisatoriske evner. Disse aktiviteter kræver, at eleverne udarbejder strategier, tager initiativ og bruger deres kreative evner til at nå et fælles mål. Aktiviteterne styrker også deres kritiske tænkning og problemløsningsfærdigheder.</p>

      <h2>Principper i praksis</h2>
      <h3>Obligatorisk deltagelse:</h3>
      <ul>
        <li>Lave ugentlig “snackbiks” og lignende.</li>
        <li>Faste arrangementer eksempelvis Sankt Hans i VitaParken, skolefest i 8. klasse, servere mad til skolearrangementer (sommerafslutning, julekoncert etc.)</li>
        <li>Klassens rejsetime</li>
      </ul>

      <h3>Valgfri deltagelse (solidarisk deltagelse):</h3>
      <ul>
        <li>Gå med flyers</li>
        <li>Køkkentjanser ved private arrangementer</li>
        <li>Havearbejde hos private, børnepasning m.m.</li>
        <li>Opgaver som tilgår ad hoc</li>
        <li>Smukfest oprydning</li>
      </ul>

      <p>Listerne skal ses som vejledende af omfanget for deltagelse. Diverse arrangementer kan ændre karakter eller omfang i løbet af årene og fra klasse til klasse.</p>
      <p>Nogle arrangementer eller opgaver kræver en vis grad af forældredeltagelse, mens andet løses alene af eleverne. Det tilstræbes, at eleverne løfter så meget som muligt selv, så den læring der er i at tjene til egen rejse bibeholdes.</p>

      <h2>Hvorfor deltagelse i fundraisingaktiviteter er vigtigt:</h2>
      <ul>
        <li><strong>Fællesskab og sammenhold:</strong> Deltagelse i at samle penge ind til udlandsrejsen, også selvom man ikke selv skal deltage, bidrager til fællesskabsfølelsen på tværs af klassen. Eleverne lærer at arbejde sammen og at respektere hinandens styrker og svagheder.</li>
        <li><strong>Ansvar og engagement:</strong> Skolen ser det som en del af dannelsesprocessen at tage ansvar og engagere sig i projekter, der rækker ud over ens egne interesser. Dette styrker sociale kompetencer og viser en vilje til at tage del i skolens demokratiske processer.</li>
        <li><strong>Læring gennem praksis:</strong> Deltagelse i fundraisingaktiviteter er ikke kun en praktisk opgave men også en læringsmulighed, hvor du udvikler færdigheder inden for kommunikation, markedsføring og samarbejde – kompetencer, der fremmer elevernes evne til at tænke og handle selvstændigt og er nyttige i mange aspekter af livet.</li>
        <li><strong>Respekt og hensyntagen:</strong> Vi forstår, at ikke alle har mulighed for at deltage i selve udlandsrejsen, og ikke alle kan deltage i alle aktiviteter. I sådanne tilfælde vil vi arbejde på at finde alternative løsninger, så vi skaber en inkluderende atmosfære, hvor enhver kan føle sig som en del af fællesskabet.</li>
        <li><strong>Solidaritet:</strong> Vi hæfter solidarisk. Det kan både betyde at stå sammen og handle til fordel for fællesskabet, også selvom man ikke selv får direkte udbytte af det, men det kan også betyde at lade den enkelte yde efter evne.</li>
      </ul>

      <h2>Spørgsmål og svar</h2>
      <p><strong>Hvad hvis jeg begynder på OLF i udskolingen?</strong><br />Når du indtræder i en 7., 8. eller 9. klasse, skal der betales ind til rejsekassen med et beløb svarende til antal elever divideret med rejsekassens pålydende ved indtræden.</p>
      <p><strong>Hvad hvis jeg stopper på OLF og har været med til at tjene pengene ind?</strong><br />De indsamlede og opsparede midler går til rejsekassen og er dermed klassens midler. Der kan derfor ikke stilles krav om at få udbetalt penge eller på anden vis godtgøres til den enkelte elev.</p>
      <p><em>Skolebestyrelsen, 2024</em></p>

      <hr />

      <div class="my-8">
        <h3 class="text-xl sm:text-2xl font-bold text-[#1D2923] mb-4 font-serif-heading">Billeder fra udlandsrejsen</h3>
        <div class="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
          <div class="overflow-hidden rounded-2xl border border-[#d9e5d4] bg-[#eef4e6] aspect-4/3 shadow-xs">
            <img src="https://assets.auxodev.dk/assets/7e157867-df92-46f8-b5ca-20179d4d9044/3_0040c910.jpg" alt="Elever på udlandsrejse 3" class="w-full h-full object-cover" />
          </div>
          <div class="overflow-hidden rounded-2xl border border-[#d9e5d4] bg-[#eef4e6] aspect-4/3 shadow-xs">
            <img src="https://assets.auxodev.dk/assets/7e157867-df92-46f8-b5ca-20179d4d9044/4_f29fa4ce.jpg" alt="Elever på udlandsrejse 4" class="w-full h-full object-cover" />
          </div>
          <div class="overflow-hidden rounded-2xl border border-[#d9e5d4] bg-[#eef4e6] aspect-4/3 shadow-xs">
            <img src="https://assets.auxodev.dk/assets/7e157867-df92-46f8-b5ca-20179d4d9044/5_eba16670.jpg" alt="Elever på udlandsrejse 5" class="w-full h-full object-cover" />
          </div>
          <div class="overflow-hidden rounded-2xl border border-[#d9e5d4] bg-[#eef4e6] aspect-4/3 shadow-xs">
            <img src="https://assets.auxodev.dk/assets/7e157867-df92-46f8-b5ca-20179d4d9044/6_a667a3eb.jpg" alt="Elever på udlandsrejse 6" class="w-full h-full object-cover" />
          </div>
          <div class="overflow-hidden rounded-2xl border border-[#d9e5d4] bg-[#eef4e6] aspect-4/3 shadow-xs">
            <img src="https://assets.auxodev.dk/assets/7e157867-df92-46f8-b5ca-20179d4d9044/2_b1a83d47.jpg" alt="Elever på udlandsrejse 2" class="w-full h-full object-cover" />
          </div>
          <div class="overflow-hidden rounded-2xl border border-[#d9e5d4] bg-[#eef4e6] aspect-4/3 shadow-xs">
            <img src="https://assets.auxodev.dk/assets/7e157867-df92-46f8-b5ca-20179d4d9044/olf11_3de1d9f9.jpg" alt="Elever på udlandsrejse OLF11" class="w-full h-full object-cover" />
          </div>
        </div>
      </div>
    `
  },

  // 19. Forældre
  "foraeldre": {
    slug: "foraeldre",
    title: "Forældre",
    summary: "Forventninger til forældre på OLF: aktiv deltagelse, arbejdsweekender, forældremøder og støtte til barnets skolegang.",
    category: "På OLF",
    hero_image: ["https://assets.auxodev.dk/assets/7e157867-df92-46f8-b5ca-20179d4d9044/olf15.jpg"],
    content: `
      <h2>Vores generelle forventninger forældre på Odder lille Friskole:</h2>
      <ul>
        <li>At I tager medansvar for, at vi fortsat har en skøn skole for jeres børn – vores elever.</li>
        <li>At I vægter sociale og faglige kompetencer lige højt.</li>
        <li>At I byder ind i forhold til det stærke fællesskab, vi betragter som unikt for OLF.</li>
        <li>At I deltager i arbejdsweekenderne eller andet planlagt forældrearbejde (2 dage pr. forælder om året).</li>
        <li>At I deltager i forældremøder og skole-hjem-samtaler. (Ved skole-hjem-samtaler skal man som forældre være opmærksom på, at hvis man udebliver fra samtalen, uden at dette er aftalt, har man ikke krav på en erstatningssamtale på et senere tidspunkt).</li>
        <li>At I støtter op om forældrearrangementer, feks. markedsdag.</li>
        <li>At I holder jer orienteret om bestyrelsens arbejde og deltager i skolens generalforsamlinger.</li>
        <li>At I, helst dagligt, holder jer orienteret på ForældreIntra, hvor en stor del af kommunikationen foregår, herunder beskeder fra lærerne og skolen.</li>
        <li>At I holder jer orienteret om, hvad der foregår i jeres barns klasse og på skolen som helhed.</li>
        <li>At I bruger de rette kommunikationskanaler/kommandoveje i forbindelse med spørgsmål til skolen, så de rette ting bliver afleveret det rette sted.</li>
        <li>At man ved optagelse på OLF er indforstået med, og støtter op omkring det værdigrundlag, skolen har – de ting vi lægger vægt på.</li>
        <li>At I kontakter klasselærerne med evt. spørgsmål, inden et problem vokser sig for stort.</li>
      </ul>

      <h2>Forventninger til dig vedr. dit barns skolegang på OLF:</h2>
      <ul>
        <li>Du støtter dit barn i det, som det har svært ved at finde ud af alene. Det kunne være hjemmearbejde, få sine ting med, medbringe de undervisningsmaterialer der skal bruges; bøger, penalhus m.m.</li>
        <li>Du støtter dit barn i at være en del at fællesskabet på OLF, og bakker skolen op i, hvor vigtigt det er at tage ansvar, både for sig selv men også for kammerater, medansvar for godt klassemiljø m.m.</li>
        <li>Dit barn kommer i skole til tiden.</li>
        <li>Du støtter op om, at dit barn respekterer og overholder de regler, der er på skolen.</li>
        <li>Dit barn har passende tøj på til f.eks. idræt, udedage, ture m.m.</li>
        <li>At du SMS’er til kontoret om morgenen, hvis dit barn er fraværende. Det er vigtig at vide, da vi fører fremmødestatistik.</li>
        <li>At børnene har seddel med, hvis de, efter aftale med jer, skal noget i løbet af dagen i skoletiden.</li>
        <li>At du tager medansvar for, at dit barn er undervisningsparat. Dvs. du snakker med dit barn om, hvordan man deltager i skolen/skolelivet. Det er vigtigt, at der er et miljø i klassen og på skolen, hvor der kan undervises, og hvor alle har det godt. Hvor rammerne for undervisning (ro, tryghed, nysgerrighed og engagement) er til stede. Hvor respekt og ansvarlighed for sine klassekammerater, andre elever, store som små, lærer, vikarer og undervisningen er en selvfølgelighed for at skabe gode læringsmiljøer.</li>
      </ul>
    `
  },

  // 20. Støttekredsen
  "stoettekredsen": {
    slug: "stoettekredsen",
    title: "Støttekredsen",
    summary: "Formål, kontingent og opbakning til Odder Lille Friskole.",
    category: "Om skolen",
    hero_image: ["https://assets.auxodev.dk/assets/7e157867-df92-46f8-b5ca-20179d4d9044/olf10.jpg"],
    content: `
      <h2>Formål</h2>
      <p>Støttekredsen på Odder lille Friskole er en forening, der har til formål:</p>
      <ul>
        <li>at støtte skolen økonomisk og praktisk</li>
        <li>at fremme fællesskabet gennem forskellige arrangementer og dermed bidrage til bevarelse af den gode OLF-ånd</li>
      </ul>
      <p>Støttekredsen er således en forening, hvor skolen kan komme med ønsker om økonomisk hjælp til nyanskaffelser, arrangementer, lejrture og hvad der ellers ikke altid lige er til på den almindelige driftskonto.</p>
      <p>Overskuddet fra kontingent og arrangementer går ubeskåret tilbage til skolen og eleverne i form af gaver og tilskud.</p>

      <h2>Kontingent og medlemskab</h2>
      <p>Støttekredsen er åben for alle, der har interesse for Odder lille Friskole. Medlemskabet er forbundet med et kontingent på <strong>kr. 150 årligt pr. familie</strong>, der betales hvert år i september. Du registreres herefter på Støtteforeningens medlemsliste. Der udstedes ikke medlemsbevis.</p>
      <p>Kontingentet på 150,- pr. husstand pr. år. kan indbetales til:<br />
      <strong>Danske Bank, reg. nr. 1551 Konto nr. 4230032063</strong></p>

      <h3>Husk:</h3>
      <ul>
        <li>at skrive barnets navn (v. OLF-familier yngste barn) på overførslen</li>
        <li>at oprette kontingentet på PBS</li>
      </ul>

      <p>Bedsteforældre, onkler, tanter mv. er meget velkomne til at melde sig ind, ligesom de også er velkomne til at deltage i Støttekredsens arrangementer. Støtteforeningen ledes af en bestyrelse, der vælges på støttekredesens egen generalforsamling, der afholdes i forbindelse med den årlige generalforsamling for Odder Lille Friskoles bestyrelse. Bestyrelsens rolle er at planlægge og være tovholdere på kredsens arrangementer. Det praktiske arbejde varetages som regel i samarbejde med andre forældre.</p>

      <p><a href="https://assets.auxodev.dk/assets/7e157867-df92-46f8-b5ca-20179d4d9044/stoettekreds-bestyrelsen-2021-22.pdf" target="_blank" rel="noopener noreferrer">Se støtteforeningen bestyrelse (PDF)</a></p>
    `
  },

  // Alias stoetteforening
  "stoetteforening": {
    slug: "stoetteforening",
    title: "Støttekredsen",
    summary: "Formål, kontingent og opbakning til Odder Lille Friskole.",
    category: "Om skolen",
    hero_image: ["https://assets.auxodev.dk/assets/7e157867-df92-46f8-b5ca-20179d4d9044/olf10.jpg"],
    content: `
      <h2>Formål</h2>
      <p>Støttekredsen på Odder lille Friskole støtter skolen økonomisk og praktisk, og fremmer fællesskabet gennem forskellige arrangementer for at bevare den gode OLF-ånd.</p>
      <h2>Kontingent og medlemskab</h2>
      <p>Kontingentet er kr. 150,- årligt pr. husstand og indbetales til Danske Bank: Reg.nr. 1551 Konto: 4230032063.</p>
      <p><a href="https://assets.auxodev.dk/assets/7e157867-df92-46f8-b5ca-20179d4d9044/stoettekreds-bestyrelsen-2021-22.pdf" target="_blank" rel="noopener noreferrer">Se støtteforeningen (PDF)</a></p>
    `
  },

  // 21. Fritteren
  "fritteren": {
    slug: "fritteren",
    title: "Fritteren & Fristed",
    summary: "Fritidstilbud til alle årgange: Fritter for 0.-5. klasse, Fristed for 6.-9. klasse, flad takst og tidlig fritter fra 1. april.",
    category: "Hverdagen",
    hero_image: ["https://assets.auxodev.dk/assets/7e157867-df92-46f8-b5ca-20179d4d9044/olf5.jpg"],
    content: `
      <h2>Fritidstilbuddet på Odder lille Friskole</h2>
      <p>Vi er glade for at kunne tilbyde fritidstilbud til alle årgange fra 0. til 9. klasse på OLF. Vores Fritteren er et vigtigt element i skolens hverdag og fungerer som et trygt og godt miljø, hvor eleverne kan udfolde sig, skabe relationer og deltage i aktiviteter. Vi har delt tilbuddet op i to former for tilbud, da indholdet er forskelligt:</p>
      <ul>
        <li><strong>Fritter (SFO)</strong> er for elever i 0.-5. klasse</li>
        <li><strong>Fristed</strong> er for elever fra 6.-9. klasse</li>
      </ul>

      <h2>Fritter (SFO) – For elever i 0.- 5. klasse</h2>
      <p>Vores pædagogiske arbejde og aktiviteter i fritteren, er målrettet elever fra 0. til 5. klasse. Dette er for at sikre, at de yngste børn får den opmærksomhed, støtte og hjælp de har brug for i deres fritid. Vi tilbyder aktiviteter, der understøtter motorik, sociale og kreative aktiviteter, og som giver dem mulighed for både leg og læring i et trygt miljø.</p>
      <p>Udover de planlagte aktiviteter i Fritteren, lægger vi stor vægt på at give børnene tid og plads til at være børn, da det er deres fritid, det handler om. Efter endt skoledag har mange børn brug for at koble af og bare lege uden den store voksenstyring og indblanding. Men selvfølgelig med voksne der er i nærheden og holder øje.</p>
      <p>Vores fritter tilbyder rammer, hvor børnene kan bruge deres fantasi og selv tage initiativ til leg. Det kan være rollelege, byggeprojekter med lego, boldspil, eller bare tid til at snakke og hygge sig med vennerne, eller noget helt andet.</p>

      <h3>Planlagte aktiviteter i Fritteren:</h3>
      <ul>
        <li>Mad over bål</li>
        <li>Just Dance</li>
        <li>Beauty Salon</li>
        <li>Boldspil</li>
        <li>Bagning i køkkenet</li>
        <li>Krea</li>
        <li>Musical</li>
        <li>TøjOLF</li>
        <li>Og meget andet…</li>
      </ul>

      <h2>Fristed – For elever i 6.- 9. klasse</h2>
      <p>Selvom vores primære fokus, pædagogiske indsats og kræfter bruges på 0.-5. klasses børn, er Fritteren også et tilbud til elever fra 6. til 9. klasse. Vi kalder det et Fristed.</p>
      <p>Vi ved, at en del af de ældre elever kan have brug for et sted at hænge ud og slappe af efter skoletid, om ikke andet for en stund, inden de skal videre til sportsaktiviteter, fritidsjob eller bare gerne vil hjem. Især når de geografisk kommer fra forskellige steder og ikke altid har mulighed for at mødes med venner der hvor de bor, eller de venter på en bus eller et lift hjem.</p>
      <p>Det fristed vi skaber, er rammer hvor de ældre elever kan mødes uden voksenstyring og indblanding, men stadig med mulighed for støtte og hjælp, hvis behovet opstår. Vi tilbyder områder på skolen, hvor de kan hænge ud med venner, snakke, spille spil eller andet. Og de er selvfølgelig altid velkomne til at komme ud til bålet og lave et snobrød, snuppe en nybagt bolle, eller bare hygge sig nede i køkkenet med de andre.</p>

      <h3>Eksempler på rammer for de ældre elever:</h3>
      <ul>
        <li><strong>Hyggeområder:</strong> Med sofaer og plads til samvær.</li>
        <li><strong>Spil og aktiviteter:</strong> Bordtennis, brætspil og adgang til kreative materialer.</li>
        <li><strong>Adgang til skolens faciliteter:</strong> Mulighed for at benytte basket- og boldbanen, Pavi, eller værksteder til selvvalgte aktiviteter.</li>
      </ul>

      <h2>Betalingsstruktur for vores fritidstilbud</h2>
      <p>På vores skole har vi valgt en <strong>flatrate betalingsstruktur</strong> for vores Fritter og Fristed. Flatrate for os betyder, at alle elever fra 0.- 9. klasse betaler det samme beløb, og det beløb dækker både skolepenge og fritidstilbud. Beløbet bliver reguleret en gang om året på vores generalforsamling. Det betyder også, at der ikke er forskel på prisen, uanset hvor meget eller hvordan Fritter og Fristedet benyttes.</p>
      <p><strong>En gennemsigtig løsning:</strong> Flatrate-modellen er baseret på en tanke om fællesskab. I stedet for at have forskellige takster, har vi valgt én samlet pris. Det gør det nemmere for jer som forældre at overskue, og sikrer, at alle familier bidrager fælles til Fritterens samlede drift.</p>
      <p><strong>Fordele for småbørnsfamilier:</strong> For de yngste børn i 0.-5. klasse betyder flatrate-modellen, at familier “slipper billigere”, end de ellers ville have gjort med en differentieret betalingsstruktur.</p>
      <p><strong>De ældre elever bidrager:</strong> Til gengæld betyder det, at de ældre elever må blive på skolen efter endt skoledag, i modsætning til mange andre skoler, hvor man skal gå hjem efter 4. klasse. Her har de en tryg base.</p>

      <h2>Kommunikation</h2>
      <p>Vi kommunikerer aktiviteter gennem årshjul på ForældreIntra, skole-hjem samtaler og på opslagstavlen ved køkkenet. Devices som iPad og tablets må kun bruges, når vi har spilledag som pædagogisk tilbud.</p>

      <h2>Pædagogiske værdier i Fritteren</h2>
      <p>Hver dag er en fra Fritter-personalet flyver/blæksprutte i Fritteren. Han/Hun holder styr på, hvem der er på skolen, og hvem der er gået hjem. Man skal altid huske at sige farvel og krydse sig ud på udkrydsningslisten der hænger ved køkkenet, inden man går.</p>

      <h2>Velkommen til tidlig Fritter på OLF!</h2>
      <p>Den 1. April åbner vi hvert år dørene for de børn, der skal starte i børnehaveklassen til august. Tidlig fritter eller “stjerneklassen”, som vi har kaldt vores klasse på OLF, er et tilbud til kommende skolebørn, hvor vi skaber en mere harmonisk overgang fra dagtilbud til skole.</p>
      <p>Stjerneklassen får navn efter den farve, deres kommende klasse får, når de starter i 0. klasse til august, f.eks. “Stjerne Lilla”.</p>
      <p>Stjerneklassen møder senest kl. 8:10 og slutter hver dag kl. 13:10. Personalet er en fast pædagog og medhjælper fra Fritteren.</p>
    `
  },

  // Alias fritteren-og-klub
  "fritteren-og-klub": {
    slug: "fritteren-og-klub",
    title: "Fritteren & Fristed",
    summary: "Fritidstilbud til alle årgange: Fritter for 0.-5. klasse, Fristed for 6.-9. klasse, flad takst og tidlig fritter fra 1. april.",
    category: "Hverdagen",
    hero_image: ["https://assets.auxodev.dk/assets/7e157867-df92-46f8-b5ca-20179d4d9044/olf5.jpg"],
    content: `
      <h2>Fritidstilbuddet på Odder lille Friskole</h2>
      <p>Vi tilbyder fritidstilbud til alle årgange fra 0. til 9. klasse på OLF. Vores Fritter er et trygt miljø med frihed til at lege, bålhygge, kreative værksteder og aktiviteter.</p>
      <h2>Fritter (0.-5. klasse) og Fristed (6.-9. klasse)</h2>
      <p>For de mindste tilbydes strukturerede og kreative aktiviteter samt fri leg. For de store elever er Fristedet en tryg base efter skoletid med hyggeområder, bordtennis, boldbaner og bålmad.</p>
      <h2>Flatrate model</h2>
      <p>Alle elever fra 0.-9. klasse betaler det samme samlede beløb, der dækker både skolepenge og fritidstilbud.</p>
      <h2>Tidlig Fritter (Stjerneklasse)</h2>
      <p>1. april starter kommende 0. klasses elever i tidlig Fritter, så de kender hinanden, de voksne og skolen inden august.</p>
    `
  },

  // 22. Musikskole
  "musikskole": {
    slug: "musikskole",
    title: "Musikskole",
    summary: "Odder Lille Friskoles egen musikskole med instrumentundervisning, sang og musikalsk fordybelse.",
    category: "Hverdagen",
    hero_image: ["https://assets.auxodev.dk/assets/7e157867-df92-46f8-b5ca-20179d4d9044/olf9.jpg"],
    content: `
      <h2>Musik skole på Odder lille Friskole</h2>
      <p>På Odder Lille Friskole har vi vores helt egen musikskole. Musikken er en integreret del af vores skoleliv, lige fra morgensang til teaterforestillinger, koncerter og soloundervisning.</p>
      <p>Gennem musikken styrker børnene deres koncentration, motorik, mod og evne til at samarbejde i fællesskab.</p>

      <h2>Se vores arbejde</h2>
      <p>Vores elever deltager i sammenspil, kor og instrumentundervisning (guitar, klaver, trommer, bas, sang m.m.), der foregår i forlængelse af skoledagen.</p>

      <h2>Vil du høre mere om Musikskolen?</h2>
      <p>Kontakt skolen på telefon <strong>86 54 38 66</strong> eller send en e-mail til <strong>olf@odderlillefriskole.dk</strong> for tilmelding og information om ledige pladser.</p>
    `
  },

  // Alias musik-og-kreativitet
  "musik-og-kreativitet": {
    slug: "musik-og-kreativitet",
    title: "Musik & kreativitet",
    summary: "Kreativ udfoldelse, sang, musik, teater og billedkunst som en naturlig del af skolelivet.",
    category: "Hverdagen",
    hero_image: ["https://assets.auxodev.dk/assets/7e157867-df92-46f8-b5ca-20179d4d9044/olf9.jpg"],
    content: `
      <h2>Musik og kreativitet på OLF</h2>
      <p>De musiske og kreative fag har en central plads i vores dannelsessyn. Gennem musik, billedkunst, drama og håndværk udfolder børnene deres fantasi og styrker deres samarbejdsevner.</p>
      <p>Alle elever stifter bekendtskab med instrumentspil, korsang og scenekunst gennem årlige forestillinger og koncerter for forældrene.</p>
      <h2>Egen musikskole</h2>
      <p>Vi tilbyder desuden undervisning i vores egen musikskole i forlængelse af skoledagen.</p>
    `
  },

  // 23. OLF-Sangen
  "olf-sangen": {
    slug: "olf-sangen",
    title: "OLF Sangen: 'Glade Børn Lærer Mest'",
    summary: "Skolens egen sang med noder og tekst skrevet af David Kildekær med børnekor fra OLF.",
    category: "Hverdagen",
    hero_image: ["https://assets.auxodev.dk/assets/7e157867-df92-46f8-b5ca-20179d4d9044/olf-sangen_9a3b98f4.png"],
    gallery_images: [
      "https://assets.auxodev.dk/assets/7e157867-df92-46f8-b5ca-20179d4d9044/olf-sangen_9a3b98f4.png"
    ],
    content: `
      <h2>OLF-sangen: 'Glade Børn Lærer Mest'</h2>
      <p>Klik på billedet nedenfor for at se noder og tekst til sangen om vores dejlige friskole.</p>
      <p><em>OLF-sangen "Glade børn lærer mest" af David Kildekær med børnekor fra Odder Lille Friskole.</em></p>
      
      <figure class="my-6 overflow-hidden rounded-2xl border border-[#d9e5d4] bg-white p-4 shadow-xs">
        <img src="https://assets.auxodev.dk/assets/7e157867-df92-46f8-b5ca-20179d4d9044/olf-sangen_9a3b98f4.png" alt="OLF Sangen noder og tekst" class="w-full h-auto object-contain max-h-[700px] mx-auto" />
      </figure>

      <blockquote>
        "Tryghed, Høj faglighed, Nærhed, Dannelse, Fællesskab, Små klasser, Trivsel, Det hele menneske, Gode relationer, Medansvar, Eksamensfri, Fritter for alle, Klasse- og projektundervisning, Personlig og faglig evaluering, Udlandsrejse i 9. kl., Engagerede medarbejdere, Egen musikskole."
      </blockquote>
    `
  },

  // 24. Praktisk information
  "praktisk-info": {
    slug: "praktisk-info",
    title: "Praktisk information",
    summary: "Mødetider, åbningstider i Fritteren, skolepenge, sygemelding og kontakt.",
    category: "Praktisk info",
    hero_image: ["https://assets.auxodev.dk/assets/7e157867-df92-46f8-b5ca-20179d4d9044/olf8.jpg"],
    content: `
      <h2>Find os</h2>
      <p><strong>Odder lille Friskole</strong><br />Randlevvej 4, 8300 Odder<br />Telefon: (+45) 86 54 38 66<br />E-mail: olf@odderlillefriskole.dk<br />CVR: 77369619</p>

      <h2>Fritteren åbningstider</h2>
      <ul>
        <li>Mandag – Torsdag: 06.45 – 16.30</li>
        <li>Fredag: 06.45 – 16.00</li>
        <li>Telefon: (+45) 86 54 38 66</li>
      </ul>

      <h2>Skoleleder</h2>
      <p><strong>Ditte-Marie Thejsen</strong><br />Telefon: 86 54 38 66<br />E-mail: <a href="mailto:dmt@odderlillefriskole.dk">dmt@odderlillefriskole.dk</a></p>

      <h2>Mødetider og skoledag</h2>
      <p>Skoledagen starter hver dag kl. 8.00 med fælles morgensang. Fritteren har åbent før skoletid fra kl. 6.45 og efter skoletid indtil kl. 16.30 (fredag til 16.00).</p>

      <h2>Skolepenge og flad takst</h2>
      <p>På Odder Lille Friskole har vi en flatrate-model for skolepenge og fritidstilbud fra 0. til 9. klasse. Der er mulighed for at søge fripladstilskud via Fordelingssekretariatet.</p>

      <h2>Sygemelding og fravær</h2>
      <p>Ved fravær bedes forældre sende en SMS til kontoret om morgenen inden kl. 07.45 af hensyn til fremmødestatistik.</p>
    `
  },

  // 25. Derfor vælger familier os
  "derfor-vaelger-familier-os": {
    slug: "derfor-vaelger-familier-os",
    title: "Derfor vælger familier os",
    summary: "Små klasser, trygge rammer og et engageret lærerkorps skaber trivsel og stærke resultater.",
    category: "Ny på skolen",
    hero_image: ["https://assets.auxodev.dk/assets/7e157867-df92-46f8-b5ca-20179d4d9044/odder-friskole-hero-happy-kids.jpg"],
    content: `
      <h2>Derfor vælger familier Odder Lille Friskole</h2>
      <p>Når forældre vælger Odder Lille Friskole, er det ofte ønsket om en tryg og overskuelig skolegang for deres barn. Hos os forsvinder eleverne ikke i mængden – her kender alle hinanden, både børn og voksne.</p>
      <p>Vi kombinerer et højt fagligt niveau med et stærkt socialt fællesskab. Børnene oplever en struktureret, men varm hverdag, hvor der er tid til den enkelte elev og plads til kreativ udfoldelse.</p>
      <p>Med vores naturskønne placering i Odder, engagerede lærere og et tæt samarbejde med forældrene skaber vi de bedste forudsætninger for børns skoleliv.</p>
      <ul>
        <li>Maksimalt 16-18 elever pr. klasse</li>
        <li>Prøvefri skole med fokus på lyst til læring</li>
        <li>Tæt samarbejde og to årlige arbejdsdage for forældre</li>
        <li>Fritidstilbud til alle årgange (0.-9. klasse)</li>
        <li>12 dages udlandsrejse i 9. klasse</li>
      </ul>
    `
  },

  // 26. Undervisning og faglighed
  "undervisning-og-faglighed": {
    slug: "undervisning-og-faglighed",
    title: "Undervisning og faglighed",
    summary: "Høj faglighed, differentieret undervisning og plads til fordybelse i mindre hold.",
    category: "Hverdagen",
    hero_image: ["https://assets.auxodev.dk/assets/7e157867-df92-46f8-b5ca-20179d4d9044/2.jpg"],
    content: `
      <h2>Undervisning og faglighed på OLF</h2>
      <p>På Odder Lille Friskole følger vi Undervisningsministeriets Fælles Mål. Vores undervisning er tilrettelagt med fokus på høj faglighed, fordybelse og differentieret støtte.</p>
      <p>De mindre klasser giver læreren mulighed for at tilpasse undervisningen til hver enkelt elevs forudsætninger, så alle bliver udfordret og oplever succes i læringen.</p>
      <p>Vi lægger vægt på tværfaglige projekter, praktisk-musiske fag, bevægelse og anvendelse af naturen som læringsrum.</p>
    `
  }
};
